{
  "en": {
    "· кадр применится ко всему видео": "· the frame applies to the whole video",
    "23 Февраля": "February 23",
    "8 Марта": "March 8",
    "Анимация готова": "Animation ready",
    "Анимация оживёт под ваш звук": "The animation will move to your sound",
    "аудио {0}": "audio {0}",
    "Аудио не прошло проверку": "The audio did not pass the check",
    "Аудио проверено": "Audio checked",
    "Аудио прочитано": "Audio read",
    "Без изменений": "No changes",
    "Без искажений": "No distortion",
    "Без лишних рук": "No extra hands",
    "Без надписей": "Without text",
    "Без политики и запрещённых тем": "No politics or prohibited topics",
    "Бесконечное зеркало со светодиодами": "Infinity mirror with LEDs",
    "близкий": "close one",
    "Близкий": "Close one",
    "Бот уже прислал его в чат, в отдельную тему.": "The bot has already sent it to the chat, in a separate topic.",
    "Ваш вариант": "Your variant",
    "Ваше видео": "Your video",
    "Ваши слова голосом «{0}»": "Your words in the voice “{0}”",
    "Ветер в волосах": "Wind in the hair",
    "вид {0}": "look {0}",
    "видео": "video",
    "Видео говорит": "Video Speaks",
    "Видео из аудио": "Video from Audio",
    "Видео не прошло проверку": "The video did not pass the check",
    "видео не создано": "the video was not created",
    "Видео повторится, пока звучит речь": "The video repeats while the speech plays",
    "Видео проверено": "Video checked",
    "Видео собрано": "Video assembled",
    "Видеооткрытка": "Video Greeting Card",
    "Видеосообщение Telegram, до минуты": "Telegram video message, up to a minute",
    "Войдёт первая минута из {0}": "Only the first minute of {0} will be used",
    "Выберите в ряду ниже": "Choose in the row below",
    "Выберите кадр": "Choose the frame",
    "Говорите: запись идёт": "Speak: recording",
    "Говорящий кружок": "Talking video message",
    "голос {0}": "voice {0}",
    "Голос вашего варианта": "Your variant’s voice",
    "Голос заменён": "Voice replaced",
    "Голос записан": "Voice recorded",
    "Голос наложен": "Voice added",
    "Голос персонажа": "Character voice",
    "Горизонт.": "Landscape",
    "Губы повторят вашу речь, до минуты": "The lips will follow your speech, up to a minute",
    "Губы синхронизированы": "Lips synced",
    "Движение сгенерирует модель STEOS": "The movement is generated by the STEOS model",
    "Для ленты": "For the feed",
    "Для Reels, Shorts и сторис": "For Reels, Shorts and stories",
    "Для YouTube и экрана": "For YouTube and screens",
    "до 1:00": "up to 1:00",
    "Доброе утро": "Good morning",
    "за видео": "per video",
    "за кружок": "per video message",
    "Загрузите видео с лицом": "Upload a video with a face",
    "Загрузите фото с лицом": "Upload a photo with a face",
    "Закончите запись": "Finish the recording",
    "Закончите съёмку": "Finish shooting",
    "Заменить аудио": "Replace audio",
    "Заменить видео": "Replace video",
    "Записываем голос": "Recording the voice",
    "Запишите или загрузите речь": "Record or upload speech",
    "Зациклить": "Loop",
    "Звук сгенерирует модель STEOS": "The sound is generated by the STEOS model",
    "из кружка": "from the video message",
    "из этого кружка": "from this video message",
    "Изменить текст": "Edit text",
    "Кадр готов": "Frame ready",
    "Кадрируем в кружок": "Cropping into a video message",
    "Кадрируем видео": "Cropping the video",
    "Как в видео": "As in the video",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "How should the photo come to life? For example: blinks, smiles, turns the head",
    "Кольцо": "Ring",
    "кружок": "video message",
    "Кружок из аудио": "Video message from audio",
    "кружок не создан": "the video message was not created",
    "Кружок собран": "Video message assembled",
    "Кто говорит?": "Who speaks?",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "The face was not visible in the frame, so the voice was added without lip sync.",
    "Лица не видно: голос наложим без подгонки губ": "The face is not visible: we’ll add the voice without lip sync",
    "Лицо в кадре, из длинного выберете минуту": "Face in the frame; from a long video you’ll pick a minute",
    "Лицо крупно и смотрит в камеру": "Face close up, looking at the camera",
    "максимум минута": "one minute max",
    "Матрица": "Matrix",
    "Микрофон недоступен, запись имитируется": "Microphone unavailable, recording is simulated",
    "Минимум {0} символов": "At least {0} characters",
    "можно своё фото или видео": "you can use your own photo or video",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "You can leave this screen: the bot will send the finished video to the chat.",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "You can leave this screen: the bot will send the finished video message to the chat.",
    "Мой голос · клон": "My voice · clone",
    "Моргает и улыбается": "Blinks and smiles",
    "Морф": "Morph",
    "Мягкое свечение, как в голосовом режиме": "Soft glow, like in voice mode",
    "на видео": "on the video",
    "на кружке": "on the video message",
    "Наезд камеры": "Camera push-in",
    "Накладываем голос на видео": "Adding the voice to the video",
    "Написать текстом": "Type it instead",
    "Напишите, что скажет": "Write what they’ll say",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "For example: hi, happy Monday, may your week be easy",
    "Не больше {0} знаков": "No more than {0} characters",
    "Не получилось собрать видео": "Could not assemble the video",
    "Не получилось собрать кружок": "Could not assemble the video message",
    "не скажет: нужен человек": "can’t speak: a person is needed",
    "Новые слова": "New words",
    "Новый год": "New Year",
    "Оживляем персонажа": "Bringing the character to life",
    "Оживляем фото": "Bringing the photo to life",
    "Оставить мою речь": "Keep my speech",
    "Осциллограф на зелёном экране": "Oscilloscope on a green screen",
    "Падающие символы": "Falling symbols",
    "Переливающаяся капля меняет форму": "A shimmering drop changes shape",
    "Персонаж ожил": "The character came to life",
    "Плавная лента звука": "A smooth ribbon of sound",
    "Поворот головы": "Head turn",
    "Проверяем аудио": "Checking the audio",
    "Проверяем видео": "Checking the video",
    "Проверяем текст": "Checking the text",
    "Проиграть кружок": "Play the video message",
    "Просто так": "Just because",
    "Пульс": "Pulse",
    "Расходящиеся круги": "Spreading circles",
    "Ретро": "Retro",
    "Речь голосом: запись или файл": "Speech by voice: recording or file",
    "Рисуем анимацию звука": "Drawing the sound animation",
    "С днём рождения": "Happy birthday",
    "С понедельником": "Happy Monday",
    "Свадьба": "Wedding",
    "своя речь": "own speech",
    "Своя речь из видео": "Own speech from the video",
    "Сделать видео": "Make a video",
    "Синхронизируем губы": "Syncing the lips",
    "Слова и голос как в видео": "Words and voice as in the video",
    "Слова и голос как в ролике": "Words and voice as in the clip",
    "Смеётся": "Laughs",
    "Собираем видео": "Assembling the video",
    "Собираем кружок": "Assembling the video message",
    "Создаём кружок": "Creating Video Message",
    "стиль {0}": "style {0}",
    "Стиль анимации": "Animation style",
    "Стиль шаблона": "Template style",
    "Столбики уровня звука": "Sound level bars",
    "Стрим": "Stream",
    "Основной": "Default",
    "Сфера": "Sphere",
    "Текст не прошёл проверку": "The text did not pass the check",
    "Текст проверен": "Text checked",
    "Только для этого кружка": "Only for this video message",
    "Тут откроется тема чата, куда бот прислал видео": "The chat topic where the bot sent the video will open here",
    "Тут откроется тема чата, куда бот прислал кружок": "The chat topic where the bot sent the video message will open here",
    "Удалить из кружка": "Remove from the video message",
    "Феррожидкость": "Ferrofluid",
    "Фон на месте": "Background stays",
    "Формат задаёт шаблон": "The template sets the format",
    "Фото говорит": "Photo Speaks",
    "Фото ожило": "The photo came to life",
    "Чего не должно": "What must not happen",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "What must not be in the frame? For example: extra hands, face distortion",
    "Чёрная магнитная жидкость с шипами": "Black magnetic liquid with spikes",
    "Читаем аудио": "Reading the audio",
    "Что вы скажете? {0}": "What will you say? {0}",
    "Что звучит вокруг? Дождь, город, костёр": "What sounds around? Rain, city, campfire",
    "Что прозвучит? {0}": "What will be heard? {0}",
    "Что происходит": "What happens",
    "Что скажет": "What they’ll say",
    "Что скажет {0}? {1}": "What will {0} say? {1}",
    "Что скажет герой? {0}": "What will the hero say? {0}",
    "Что скажет человек в кадре? {0}": "What will the person in the frame say? {0}"
  },
  "hy": {
    "· кадр применится ко всему видео": "· կադրը կկիրառվի ամբողջ տեսանյութին",
    "23 Февраля": "Փետրվարի 23",
    "8 Марта": "Մարտի 8",
    "Анимация готова": "Անիմացիան պատրաստ է",
    "Анимация оживёт под ваш звук": "Անիմացիան կկենդանանա ձեր ձայնի ներքո",
    "аудио {0}": "աուդիո {0}",
    "Аудио не прошло проверку": "Աուդիոն չանցավ ստուգումը",
    "Аудио проверено": "Աուդիոն ստուգված է",
    "Аудио прочитано": "Աուդիոն կարդացված է",
    "Без изменений": "Առանց փոփոխության",
    "Без искажений": "Առանց աղավաղումների",
    "Без лишних рук": "Առանց ավելորդ ձեռքերի",
    "Без надписей": "Առանց գրությունների",
    "Без политики и запрещённых тем": "Առանց քաղաքականության և արգելված թեմաների",
    "Бесконечное зеркало со светодиодами": "Անվերջ հայելի լուսադիոդներով",
    "близкий": "մտերիմ",
    "Близкий": "Մտերիմ",
    "Бот уже прислал его в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է այն չատ՝ առանձին թեմայում։",
    "Ваш вариант": "Ձեր տարբերակը",
    "Ваше видео": "Ձեր տեսանյութը",
    "Ваши слова голосом «{0}»": "Ձեր խոսքերը «{0}» ձայնով",
    "Ветер в волосах": "Քամին մազերում",
    "вид {0}": "տեսք {0}",
    "видео": "տեսանյութ",
    "Видео говорит": "Տեսանյութը խոսում է",
    "Видео из аудио": "Տեսանյութ աուդիոյից",
    "Видео не прошло проверку": "Տեսանյութը չանցավ ստուգումը",
    "видео не создано": "տեսանյութը չստեղծվեց",
    "Видео повторится, пока звучит речь": "Տեսանյութը կկրկնվի, քանի դեռ հնչում է խոսքը",
    "Видео проверено": "Տեսանյութը ստուգված է",
    "Видео собрано": "Տեսանյութը հավաքված է",
    "Видеооткрытка": "Տեսաբացիկ",
    "Видеосообщение Telegram, до минуты": "Telegram-ի տեսահաղորդագրություն՝ մինչև մեկ րոպե",
    "Войдёт первая минута из {0}": "{0}-ից կօգտագործվի առաջին րոպեն",
    "Выберите в ряду ниже": "Ընտրեք ստորև շարքից",
    "Выберите кадр": "Ընտրեք կադրը",
    "Говорите: запись идёт": "Խոսեք՝ ձայնագրվում է",
    "Говорящий кружок": "Խոսող տեսահաղորդագրություն",
    "голос {0}": "ձայն՝ {0}",
    "Голос вашего варианта": "Ձեր տարբերակի ձայնը",
    "Голос заменён": "Ձայնը փոխարինված է",
    "Голос записан": "Ձայնը ձայնագրված է",
    "Голос наложен": "Ձայնը վերադրված է",
    "Голос персонажа": "Կերպարի ձայնը",
    "Горизонт.": "Հորիզոն.",
    "Губы повторят вашу речь, до минуты": "Շուրթերը կկրկնեն ձեր խոսքը՝ մինչև մեկ րոպե",
    "Губы синхронизированы": "Շուրթերը համաժամեցված են",
    "Движение сгенерирует модель STEOS": "Շարժումը կստեղծի STEOS մոդելը",
    "Для ленты": "Լրահոսի համար",
    "Для Reels, Shorts и сторис": "Reels-ի, Shorts-ի և սթորիների համար",
    "Для YouTube и экрана": "YouTube-ի և էկրանի համար",
    "до 1:00": "մինչև 1:00",
    "Доброе утро": "Բարի լույս",
    "за видео": "մեկ տեսանյութի համար",
    "за кружок": "մեկ շրջանաձև տեսանյութի համար",
    "Загрузите видео с лицом": "Վերբեռնեք դեմքով տեսանյութ",
    "Загрузите фото с лицом": "Վերբեռնեք դեմքով լուսանկար",
    "Закончите запись": "Ավարտեք ձայնագրությունը",
    "Закончите съёмку": "Ավարտեք նկարահանումը",
    "Заменить аудио": "Փոխարինել աուդիոն",
    "Заменить видео": "Փոխարինել տեսանյութը",
    "Записываем голос": "Ձայնագրում ենք ձայնը",
    "Запишите или загрузите речь": "Ձայնագրեք կամ վերբեռնեք խոսքը",
    "Зациклить": "Կրկնել",
    "Звук сгенерирует модель STEOS": "Ձայնը կստեղծի STEOS մոդելը",
    "из кружка": "շրջանաձև տեսանյութից",
    "из этого кружка": "այս շրջանաձև տեսանյութից",
    "Изменить текст": "Փոխել տեքստը",
    "Кадр готов": "Կադրը պատրաստ է",
    "Кадрируем в кружок": "Կադրավորում ենք շրջանաձև տեսանյութի համար",
    "Кадрируем видео": "Կադրավորում ենք տեսանյութը",
    "Как в видео": "Ինչպես տեսանյութում",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "Ինչպե՞ս կենդանացնել լուսանկարը։ Օրինակ՝ թարթում է, ժպտում, գլուխը շրջում",
    "Кольцо": "Օղակ",
    "кружок": "շրջանաձև տեսանյութ",
    "Кружок из аудио": "Տեսահաղորդագրություն աուդիոյից",
    "кружок не создан": "շրջանաձև տեսանյութը չստեղծվեց",
    "Кружок собран": "Շրջանաձև տեսանյութը հավաքված է",
    "Кто говорит?": "Ո՞վ է խոսում",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "Դեմքը կադրում չէր երևում, ուստի ձայնը վերադրվել է առանց շուրթերի համաժամեցման։",
    "Лица не видно: голос наложим без подгонки губ": "Դեմքը չի երևում․ ձայնը կվերադրենք առանց շուրթերի համաժամեցման",
    "Лицо в кадре, из длинного выберете минуту": "Դեմքը կադրում, երկարից կընտրեք մեկ րոպե",
    "Лицо крупно и смотрит в камеру": "Դեմքը խոշոր պլանով և նայում է տեսախցիկին",
    "максимум минута": "առավելագույնը մեկ րոպե",
    "Матрица": "Մատրիցա",
    "Микрофон недоступен, запись имитируется": "Խոսափողը հասանելի չէ, ձայնագրությունը նմանակվում է",
    "Минимум {0} символов": "Առնվազն {0} նիշ",
    "можно своё фото или видео": "կարելի է օգտագործել ձեր լուսանկարը կամ տեսանյութը",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "Կարող եք դուրս գալ էկրանից․ բոտը պատրաստ տեսանյութը կուղարկի չատ։",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "Կարող եք դուրս գալ էկրանից․ բոտը պատրաստ շրջանաձև տեսանյութը կուղարկի չատ։",
    "Мой голос · клон": "Իմ ձայնը · կլոն",
    "Моргает и улыбается": "Թարթում է և ժպտում",
    "Морф": "Մորֆ",
    "Мягкое свечение, как в голосовом режиме": "Մեղմ փայլ, ինչպես ձայնային ռեժիմում",
    "на видео": "տեսանյութի վրա",
    "на кружке": "շրջանաձև տեսանյութի վրա",
    "Наезд камеры": "Տեսախցիկի մոտեցում",
    "Накладываем голос на видео": "Ձայնը վերադրում ենք տեսանյութին",
    "Написать текстом": "Գրել տեքստով",
    "Напишите, что скажет": "Գրեք, թե ինչ է ասելու",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "Օրինակ՝ բարև, բարի երկուշաբթի, թող շաբաթը թեթև լինի",
    "Не больше {0} знаков": "Ոչ ավելի, քան {0} նիշ",
    "Не получилось собрать видео": "Չհաջողվեց հավաքել տեսանյութը",
    "Не получилось собрать кружок": "Չհաջողվեց հավաքել շրջանաձև տեսանյութը",
    "не скажет: нужен человек": "չի խոսի․ անհրաժեշտ է մարդ",
    "Новые слова": "Նոր բառեր",
    "Новый год": "Նոր տարի",
    "Оживляем персонажа": "Կենդանացնում ենք կերպարին",
    "Оживляем фото": "Կենդանացնում ենք լուսանկարը",
    "Оставить мою речь": "Թողնել իմ խոսքը",
    "Осциллограф на зелёном экране": "Օսցիլոգրաֆ կանաչ էկրանին",
    "Падающие символы": "Ընկնող նշաններ",
    "Переливающаяся капля меняет форму": "Փայլփլուն կաթիլը փոխում է ձևը",
    "Персонаж ожил": "Կերպարը կենդանացավ",
    "Плавная лента звука": "Ձայնի սահուն ժապավեն",
    "Поворот головы": "Գլխի շրջում",
    "Проверяем аудио": "Ստուգում ենք աուդիոն",
    "Проверяем видео": "Ստուգում ենք տեսանյութը",
    "Проверяем текст": "Ստուգում ենք տեքստը",
    "Проиграть кружок": "Նվագարկել շրջանաձև տեսանյութը",
    "Просто так": "Հենց այնպես",
    "Пульс": "Զարկ",
    "Расходящиеся круги": "Տարածվող շրջանակներ",
    "Ретро": "Ռետրո",
    "Речь голосом: запись или файл": "Խոսք ձայնով՝ ձայնագրություն կամ ֆայլ",
    "Рисуем анимацию звука": "Նկարում ենք ձայնի անիմացիան",
    "С днём рождения": "Ծնունդդ շնորհավոր",
    "С понедельником": "Բարի երկուշաբթի",
    "Свадьба": "Հարսանիք",
    "своя речь": "սեփական խոսք",
    "Своя речь из видео": "Սեփական խոսքը տեսանյութից",
    "Сделать видео": "Ստեղծել տեսանյութ",
    "Синхронизируем губы": "Համաժամեցնում ենք շուրթերը",
    "Слова и голос как в видео": "Բառերն ու ձայնը՝ ինչպես տեսանյութում",
    "Слова и голос как в ролике": "Բառերն ու ձայնը՝ ինչպես հոլովակում",
    "Смеётся": "Ծիծաղում է",
    "Собираем видео": "Հավաքում ենք տեսանյութը",
    "Собираем кружок": "Հավաքում ենք շրջանաձև տեսանյութը",
    "Создаём кружок": "Ստեղծվում է շրջանաձև տեսանյութը",
    "стиль {0}": "ոճ {0}",
    "Стиль анимации": "Անիմացիայի ոճ",
    "Стиль шаблона": "Ձևանմուշի ոճ",
    "Столбики уровня звука": "Ձայնի մակարդակի սյուներ",
    "Стрим": "Ստրիմ",
    "Основной": "Հիմնական",
    "Сфера": "Գունդ",
    "Текст не прошёл проверку": "Տեքստը չանցավ ստուգումը",
    "Текст проверен": "Տեքստը ստուգված է",
    "Только для этого кружка": "Միայն այս շրջանաձև տեսանյութի համար",
    "Тут откроется тема чата, куда бот прислал видео": "Այստեղ կբացվի չատի թեման, որտեղ բոտն ուղարկել է տեսանյութը",
    "Тут откроется тема чата, куда бот прислал кружок": "Այստեղ կբացվի չատի թեման, որտեղ բոտն ուղարկել է շրջանաձև տեսանյութը",
    "Удалить из кружка": "Հեռացնել շրջանաձև տեսանյութից",
    "Феррожидкость": "Ֆեռոհեղուկ",
    "Фон на месте": "Ֆոնը տեղում է",
    "Формат задаёт шаблон": "Ձևաչափը սահմանում է ձևանմուշը",
    "Фото говорит": "Լուսանկարը խոսում է",
    "Фото ожило": "Լուսանկարը կենդանացավ",
    "Чего не должно": "Ինչը չպետք է լինի",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "Ի՞նչը չպետք է լինի կադրում։ Օրինակ՝ ավելորդ ձեռքեր, դեմքի աղավաղումներ",
    "Чёрная магнитная жидкость с шипами": "Սև մագնիսական հեղուկ փշերով",
    "Читаем аудио": "Կարդում ենք աուդիոն",
    "Что вы скажете? {0}": "Ի՞նչ կասեք։ {0}",
    "Что звучит вокруг? Дождь, город, костёр": "Ի՞նչ է հնչում շուրջը։ Անձրև, քաղաք, խարույկ",
    "Что прозвучит? {0}": "Ի՞նչ կհնչի։ {0}",
    "Что происходит": "Ինչ է կատարվում",
    "Что скажет": "Ինչ կասի",
    "Что скажет {0}? {1}": "Ի՞նչ կասի {0}։ {1}",
    "Что скажет герой? {0}": "Ի՞նչ կասի հերոսը։ {0}",
    "Что скажет человек в кадре? {0}": "Ի՞նչ կասի կադրում գտնվող մարդը։ {0}"
  },
  "es": {
    "· кадр применится ко всему видео": "· el encuadre se aplicará a todo el vídeo",
    "23 Февраля": "23 de febrero",
    "8 Марта": "8 de marzo",
    "Анимация готова": "Animación lista",
    "Анимация оживёт под ваш звук": "La animación cobrará vida con tu sonido",
    "аудио {0}": "audio {0}",
    "Аудио не прошло проверку": "El audio no pasó la verificación",
    "Аудио проверено": "Audio verificado",
    "Аудио прочитано": "Audio leído",
    "Без изменений": "Sin cambios",
    "Без искажений": "Sin distorsiones",
    "Без лишних рук": "Sin manos de más",
    "Без надписей": "Sin texto",
    "Без политики и запрещённых тем": "Sin política ni temas prohibidos",
    "Бесконечное зеркало со светодиодами": "Espejo infinito con LED",
    "близкий": "ser querido",
    "Близкий": "Ser querido",
    "Бот уже прислал его в чат, в отдельную тему.": "El bot ya lo envió al chat, en un tema aparte.",
    "Ваш вариант": "Tu variante",
    "Ваше видео": "Tu vídeo",
    "Ваши слова голосом «{0}»": "Tus palabras con la voz «{0}»",
    "Ветер в волосах": "Viento en el pelo",
    "вид {0}": "aspecto {0}",
    "видео": "vídeo",
    "Видео говорит": "El vídeo habla",
    "Видео из аудио": "Vídeo desde audio",
    "Видео не прошло проверку": "El vídeo no pasó la verificación",
    "видео не создано": "el vídeo no se creó",
    "Видео повторится, пока звучит речь": "El vídeo se repetirá mientras suene la voz",
    "Видео проверено": "Vídeo verificado",
    "Видео собрано": "Vídeo montado",
    "Видеооткрытка": "Videotarjeta",
    "Видеосообщение Telegram, до минуты": "Videomensaje de Telegram, hasta un minuto",
    "Войдёт первая минута из {0}": "Se usará el primer minuto de {0}",
    "Выберите в ряду ниже": "Elige en la fila de abajo",
    "Выберите кадр": "Elige el encuadre",
    "Говорите: запись идёт": "Habla: grabando",
    "Говорящий кружок": "Videomensaje parlante",
    "голос {0}": "voz {0}",
    "Голос вашего варианта": "Voz de tu variante",
    "Голос заменён": "Voz reemplazada",
    "Голос записан": "Voz grabada",
    "Голос наложен": "Voz superpuesta",
    "Голос персонажа": "Voz del personaje",
    "Горизонт.": "Horizontal",
    "Губы повторят вашу речь, до минуты": "Los labios seguirán tu voz, hasta un minuto",
    "Губы синхронизированы": "Labios sincronizados",
    "Движение сгенерирует модель STEOS": "El movimiento lo genera el modelo STEOS",
    "Для ленты": "Para el feed",
    "Для Reels, Shorts и сторис": "Para Reels, Shorts e historias",
    "Для YouTube и экрана": "Para YouTube y pantalla",
    "до 1:00": "hasta 1:00",
    "Доброе утро": "Buenos días",
    "за видео": "por vídeo",
    "за кружок": "por círculo",
    "Загрузите видео с лицом": "Sube un vídeo con una cara",
    "Загрузите фото с лицом": "Sube una foto con una cara",
    "Закончите запись": "Termina la grabación",
    "Закончите съёмку": "Termina de grabar",
    "Заменить аудио": "Reemplazar audio",
    "Заменить видео": "Reemplazar vídeo",
    "Записываем голос": "Grabando la voz",
    "Запишите или загрузите речь": "Graba o sube la voz",
    "Зациклить": "Repetir en bucle",
    "Звук сгенерирует модель STEOS": "El sonido lo genera el modelo STEOS",
    "из кружка": "del círculo",
    "из этого кружка": "de este círculo",
    "Изменить текст": "Editar texto",
    "Кадр готов": "Encuadre listo",
    "Кадрируем в кружок": "Encuadrando en círculo",
    "Кадрируем видео": "Encuadrando el vídeo",
    "Как в видео": "Como en el vídeo",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "¿Cómo dar vida a la foto? Por ejemplo: parpadea, sonríe, gira la cabeza",
    "Кольцо": "Anillo",
    "кружок": "círculo",
    "Кружок из аудио": "Videomensaje desde audio",
    "кружок не создан": "el círculo no se creó",
    "Кружок собран": "Círculo montado",
    "Кто говорит?": "¿Quién habla?",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "La cara no se veía en el encuadre, así que la voz se superpuso sin sincronizar los labios.",
    "Лица не видно: голос наложим без подгонки губ": "No se ve la cara: superpondremos la voz sin sincronizar los labios",
    "Лицо в кадре, из длинного выберете минуту": "Cara en el encuadre; de uno largo elegirás un minuto",
    "Лицо крупно и смотрит в камеру": "Cara de cerca y mirando a la cámara",
    "максимум минута": "un minuto como máximo",
    "Матрица": "Matriz",
    "Микрофон недоступен, запись имитируется": "Micrófono no disponible, la grabación se simula",
    "Минимум {0} символов": "Mínimo {0} caracteres",
    "можно своё фото или видео": "puedes usar tu propia foto o vídeo",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "Puedes salir de la pantalla: el bot enviará el vídeo terminado al chat.",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "Puedes salir de la pantalla: el bot enviará el círculo terminado al chat.",
    "Мой голос · клон": "Mi voz · clon",
    "Моргает и улыбается": "Parpadea y sonríe",
    "Морф": "Morph",
    "Мягкое свечение, как в голосовом режиме": "Brillo suave, como en el modo de voz",
    "на видео": "en el vídeo",
    "на кружке": "en el círculo",
    "Наезд камеры": "Acercamiento de cámara",
    "Накладываем голос на видео": "Superponiendo la voz al vídeo",
    "Написать текстом": "Escribir con texto",
    "Напишите, что скажет": "Escribe qué dirá",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "Por ejemplo: hola, feliz lunes, que la semana sea ligera",
    "Не больше {0} знаков": "No más de {0} caracteres",
    "Не получилось собрать видео": "No se pudo montar el vídeo",
    "Не получилось собрать кружок": "No se pudo montar el círculo",
    "не скажет: нужен человек": "no puede hablar: se necesita una persona",
    "Новые слова": "Nuevas palabras",
    "Новый год": "Año Nuevo",
    "Оживляем персонажа": "Dando vida al personaje",
    "Оживляем фото": "Dando vida a la foto",
    "Оставить мою речь": "Mantener mi voz",
    "Осциллограф на зелёном экране": "Osciloscopio en pantalla verde",
    "Падающие символы": "Símbolos que caen",
    "Переливающаяся капля меняет форму": "Una gota tornasolada cambia de forma",
    "Персонаж ожил": "El personaje cobró vida",
    "Плавная лента звука": "Una cinta de sonido fluida",
    "Поворот головы": "Giro de cabeza",
    "Проверяем аудио": "Verificando el audio",
    "Проверяем видео": "Verificando el vídeo",
    "Проверяем текст": "Verificando el texto",
    "Проиграть кружок": "Reproducir el círculo",
    "Просто так": "Porque sí",
    "Пульс": "Pulso",
    "Расходящиеся круги": "Círculos que se expanden",
    "Ретро": "Retro",
    "Речь голосом: запись или файл": "Voz hablada: grabación o archivo",
    "Рисуем анимацию звука": "Dibujando la animación del sonido",
    "С днём рождения": "Feliz cumpleaños",
    "С понедельником": "Feliz lunes",
    "Свадьба": "Boda",
    "своя речь": "voz propia",
    "Своя речь из видео": "Voz propia del vídeo",
    "Сделать видео": "Hacer vídeo",
    "Синхронизируем губы": "Sincronizando los labios",
    "Слова и голос как в видео": "Palabras y voz como en el vídeo",
    "Слова и голос как в ролике": "Palabras y voz como en el clip",
    "Смеётся": "Se ríe",
    "Собираем видео": "Montando el vídeo",
    "Собираем кружок": "Montando el círculo",
    "Создаём кружок": "Creando el círculo",
    "стиль {0}": "estilo {0}",
    "Стиль анимации": "Estilo de animación",
    "Стиль шаблона": "Estilo de la plantilla",
    "Столбики уровня звука": "Barras de nivel de sonido",
    "Стрим": "Stream",
    "Основной": "Principal",
    "Сфера": "Esfera",
    "Текст не прошёл проверку": "El texto no pasó la verificación",
    "Текст проверен": "Texto verificado",
    "Только для этого кружка": "Solo para este círculo",
    "Тут откроется тема чата, куда бот прислал видео": "Aquí se abrirá el tema del chat donde el bot envió el vídeo",
    "Тут откроется тема чата, куда бот прислал кружок": "Aquí se abrirá el tema del chat donde el bot envió el círculo",
    "Удалить из кружка": "Quitar del círculo",
    "Феррожидкость": "Ferrofluido",
    "Фон на месте": "Fondo fijo",
    "Формат задаёт шаблон": "La plantilla define el formato",
    "Фото говорит": "La foto habla",
    "Фото ожило": "La foto cobró vida",
    "Чего не должно": "Lo que no debe pasar",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "¿Qué no debe aparecer? Por ejemplo: manos de más, distorsión de la cara",
    "Чёрная магнитная жидкость с шипами": "Líquido magnético negro con púas",
    "Читаем аудио": "Leyendo el audio",
    "Что вы скажете? {0}": "¿Qué dirás? {0}",
    "Что звучит вокруг? Дождь, город, костёр": "¿Qué suena alrededor? Lluvia, ciudad, fogata",
    "Что прозвучит? {0}": "¿Qué sonará? {0}",
    "Что происходит": "Qué pasa",
    "Что скажет": "Qué dirá",
    "Что скажет {0}? {1}": "¿Qué dirá {0}? {1}",
    "Что скажет герой? {0}": "¿Qué dirá el protagonista? {0}",
    "Что скажет человек в кадре? {0}": "¿Qué dirá la persona del encuadre? {0}"
  },
  "de": {
    "· кадр применится ко всему видео": "· der Ausschnitt gilt für das ganze Video",
    "23 Февраля": "23. Februar",
    "8 Марта": "8. März",
    "Анимация готова": "Animation fertig",
    "Анимация оживёт под ваш звук": "Die Animation bewegt sich zu Ihrem Ton",
    "аудио {0}": "Audio {0}",
    "Аудио не прошло проверку": "Das Audio hat die Prüfung nicht bestanden",
    "Аудио проверено": "Audio geprüft",
    "Аудио прочитано": "Audio gelesen",
    "Без изменений": "Unverändert",
    "Без искажений": "Ohne Verzerrungen",
    "Без лишних рук": "Keine zusätzlichen Hände",
    "Без надписей": "Ohne Text",
    "Без политики и запрещённых тем": "Keine Politik und keine verbotenen Themen",
    "Бесконечное зеркало со светодиодами": "Unendlichkeitsspiegel mit LEDs",
    "близкий": "nahestehende Person",
    "Близкий": "Nahestehende Person",
    "Бот уже прислал его в чат, в отдельную тему.": "Der Bot hat es bereits in einem eigenen Thema in den Chat geschickt.",
    "Ваш вариант": "Ihre Variante",
    "Ваше видео": "Ihr Video",
    "Ваши слова голосом «{0}»": "Ihre Worte mit der Stimme „{0}“",
    "Ветер в волосах": "Wind im Haar",
    "вид {0}": "Look {0}",
    "видео": "Video",
    "Видео говорит": "Video spricht",
    "Видео из аудио": "Video aus Audio",
    "Видео не прошло проверку": "Das Video hat die Prüfung nicht bestanden",
    "видео не создано": "das Video wurde nicht erstellt",
    "Видео повторится, пока звучит речь": "Das Video wiederholt sich, solange die Sprache läuft",
    "Видео проверено": "Video geprüft",
    "Видео собрано": "Video zusammengestellt",
    "Видеооткрытка": "Videogrußkarte",
    "Видеосообщение Telegram, до минуты": "Telegram-Videonachricht, bis zu einer Minute",
    "Войдёт первая минута из {0}": "Es wird die erste Minute von {0} verwendet",
    "Выберите в ряду ниже": "Wählen Sie in der Reihe unten",
    "Выберите кадр": "Wählen Sie den Ausschnitt",
    "Говорите: запись идёт": "Sprechen Sie: Aufnahme läuft",
    "Говорящий кружок": "Sprechende Videonachricht",
    "голос {0}": "Stimme {0}",
    "Голос вашего варианта": "Stimme Ihrer Variante",
    "Голос заменён": "Stimme ersetzt",
    "Голос записан": "Stimme aufgenommen",
    "Голос наложен": "Stimme hinzugefügt",
    "Голос персонажа": "Stimme der Figur",
    "Горизонт.": "Horizontal",
    "Губы повторят вашу речь, до минуты": "Die Lippen folgen Ihrer Sprache, bis zu einer Minute",
    "Губы синхронизированы": "Lippen synchronisiert",
    "Движение сгенерирует модель STEOS": "Die Bewegung erzeugt das STEOS-Modell",
    "Для ленты": "Für den Feed",
    "Для Reels, Shorts и сторис": "Für Reels, Shorts und Storys",
    "Для YouTube и экрана": "Für YouTube und Bildschirme",
    "до 1:00": "bis 1:00",
    "Доброе утро": "Guten Morgen",
    "за видео": "pro Video",
    "за кружок": "pro Videonachricht",
    "Загрузите видео с лицом": "Laden Sie ein Video mit Gesicht hoch",
    "Загрузите фото с лицом": "Laden Sie ein Foto mit Gesicht hoch",
    "Закончите запись": "Beenden Sie die Aufnahme",
    "Закончите съёмку": "Beenden Sie die Kameraaufnahme",
    "Заменить аудио": "Audio ersetzen",
    "Заменить видео": "Video ersetzen",
    "Записываем голос": "Stimme wird aufgenommen",
    "Запишите или загрузите речь": "Sprache aufnehmen oder hochladen",
    "Зациклить": "Wiederholen",
    "Звук сгенерирует модель STEOS": "Den Ton erzeugt das STEOS-Modell",
    "из кружка": "aus der Videonachricht",
    "из этого кружка": "aus dieser Videonachricht",
    "Изменить текст": "Text bearbeiten",
    "Кадр готов": "Ausschnitt fertig",
    "Кадрируем в кружок": "Zuschnitt für die Videonachricht",
    "Кадрируем видео": "Video wird zugeschnitten",
    "Как в видео": "Wie im Video",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "Wie soll das Foto lebendig werden? Zum Beispiel: blinzelt, lächelt, dreht den Kopf",
    "Кольцо": "Ring",
    "кружок": "Videonachricht",
    "Кружок из аудио": "Videonachricht aus Audio",
    "кружок не создан": "die Videonachricht wurde nicht erstellt",
    "Кружок собран": "Videonachricht zusammengestellt",
    "Кто говорит?": "Wer spricht?",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "Das Gesicht war im Bild nicht zu sehen, daher wurde die Stimme ohne Lippensynchronisation hinzugefügt.",
    "Лица не видно: голос наложим без подгонки губ": "Das Gesicht ist nicht zu sehen: Wir fügen die Stimme ohne Lippensynchronisation hinzu",
    "Лицо в кадре, из длинного выберете минуту": "Gesicht im Bild; aus einem langen Video wählen Sie eine Minute",
    "Лицо крупно и смотрит в камеру": "Gesicht groß im Bild, Blick in die Kamera",
    "максимум минута": "maximal eine Minute",
    "Матрица": "Matrix",
    "Микрофон недоступен, запись имитируется": "Mikrofon nicht verfügbar, die Aufnahme wird simuliert",
    "Минимум {0} символов": "Mindestens {0} Zeichen",
    "можно своё фото или видео": "auch eigenes Foto oder Video möglich",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "Sie können den Bildschirm verlassen: Der Bot schickt das fertige Video in den Chat.",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "Sie können den Bildschirm verlassen: Der Bot schickt die fertige Videonachricht in den Chat.",
    "Мой голос · клон": "Meine Stimme · Klon",
    "Моргает и улыбается": "Blinzelt und lächelt",
    "Морф": "Morph",
    "Мягкое свечение, как в голосовом режиме": "Sanftes Leuchten wie im Sprachmodus",
    "на видео": "im Video",
    "на кружке": "auf der Videonachricht",
    "Наезд камеры": "Kamerafahrt nach vorn",
    "Накладываем голос на видео": "Stimme wird zum Video hinzugefügt",
    "Написать текстом": "Als Text schreiben",
    "Напишите, что скажет": "Schreiben Sie, was gesagt werden soll",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "Zum Beispiel: Hallo, schönen Montag, möge die Woche leicht werden",
    "Не больше {0} знаков": "Höchstens {0} Zeichen",
    "Не получилось собрать видео": "Das Video konnte nicht erstellt werden",
    "Не получилось собрать кружок": "Die Videonachricht konnte nicht erstellt werden",
    "не скажет: нужен человек": "kann nicht sprechen: ein Mensch ist nötig",
    "Новые слова": "Neue Worte",
    "Новый год": "Neujahr",
    "Оживляем персонажа": "Die Figur wird lebendig",
    "Оживляем фото": "Das Foto wird lebendig",
    "Оставить мою речь": "Meine Sprache behalten",
    "Осциллограф на зелёном экране": "Oszilloskop auf grünem Bildschirm",
    "Падающие символы": "Fallende Zeichen",
    "Переливающаяся капля меняет форму": "Ein schillernder Tropfen verändert seine Form",
    "Персонаж ожил": "Die Figur ist lebendig",
    "Плавная лента звука": "Ein fließendes Klangband",
    "Поворот головы": "Kopfdrehung",
    "Проверяем аудио": "Audio wird geprüft",
    "Проверяем видео": "Video wird geprüft",
    "Проверяем текст": "Text wird geprüft",
    "Проиграть кружок": "Videonachricht abspielen",
    "Просто так": "Einfach so",
    "Пульс": "Puls",
    "Расходящиеся круги": "Sich ausbreitende Kreise",
    "Ретро": "Retro",
    "Речь голосом: запись или файл": "Sprache per Stimme: Aufnahme oder Datei",
    "Рисуем анимацию звука": "Soundanimation wird gezeichnet",
    "С днём рождения": "Alles Gute zum Geburtstag",
    "С понедельником": "Schönen Montag",
    "Свадьба": "Hochzeit",
    "своя речь": "eigene Sprache",
    "Своя речь из видео": "Eigene Sprache aus dem Video",
    "Сделать видео": "Video daraus machen",
    "Синхронизируем губы": "Lippen werden synchronisiert",
    "Слова и голос как в видео": "Worte und Stimme wie im Video",
    "Слова и голос как в ролике": "Worte und Stimme wie im Clip",
    "Смеётся": "Lacht",
    "Собираем видео": "Video wird zusammengestellt",
    "Собираем кружок": "Videonachricht wird zusammengestellt",
    "Создаём кружок": "Videonachricht wird erstellt",
    "стиль {0}": "Stil {0}",
    "Стиль анимации": "Animationsstil",
    "Стиль шаблона": "Vorlagenstil",
    "Столбики уровня звука": "Pegelbalken",
    "Стрим": "Stream",
    "Основной": "Standard",
    "Сфера": "Sphäre",
    "Текст не прошёл проверку": "Der Text hat die Prüfung nicht bestanden",
    "Текст проверен": "Text geprüft",
    "Только для этого кружка": "Nur für diese Videonachricht",
    "Тут откроется тема чата, куда бот прислал видео": "Hier öffnet sich das Chat-Thema, in das der Bot das Video geschickt hat",
    "Тут откроется тема чата, куда бот прислал кружок": "Hier öffnet sich das Chat-Thema, in das der Bot die Videonachricht geschickt hat",
    "Удалить из кружка": "Aus der Videonachricht entfernen",
    "Феррожидкость": "Ferrofluid",
    "Фон на месте": "Hintergrund bleibt",
    "Формат задаёт шаблон": "Das Format legt die Vorlage fest",
    "Фото говорит": "Foto spricht",
    "Фото ожило": "Das Foto ist lebendig",
    "Чего не должно": "Was nicht passieren soll",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "Was darf nicht im Bild sein? Zum Beispiel: zusätzliche Hände, verzerrte Gesichter",
    "Чёрная магнитная жидкость с шипами": "Schwarze magnetische Flüssigkeit mit Stacheln",
    "Читаем аудио": "Audio wird gelesen",
    "Что вы скажете? {0}": "Was sagen Sie? {0}",
    "Что звучит вокруг? Дождь, город, костёр": "Was ist ringsum zu hören? Regen, Stadt, Lagerfeuer",
    "Что прозвучит? {0}": "Was soll zu hören sein? {0}",
    "Что происходит": "Was passiert",
    "Что скажет": "Was gesagt wird",
    "Что скажет {0}? {1}": "Was sagt {0}? {1}",
    "Что скажет герой? {0}": "Was sagt die Figur? {0}",
    "Что скажет человек в кадре? {0}": "Was sagt die Person im Bild? {0}"
  },
  "fr": {
    "· кадр применится ко всему видео": "· le cadrage s’appliquera à toute la vidéo",
    "23 Февраля": "23 février",
    "8 Марта": "8 mars",
    "Анимация готова": "Animation prête",
    "Анимация оживёт под ваш звук": "L’animation suivra votre son",
    "аудио {0}": "audio {0}",
    "Аудио не прошло проверку": "L’audio n’a pas passé la vérification",
    "Аудио проверено": "Audio vérifié",
    "Аудио прочитано": "Audio lu",
    "Без изменений": "Sans modification",
    "Без искажений": "Sans déformation",
    "Без лишних рук": "Pas de mains en trop",
    "Без надписей": "Sans texte",
    "Без политики и запрещённых тем": "Pas de politique ni de sujets interdits",
    "Бесконечное зеркало со светодиодами": "Miroir infini à LED",
    "близкий": "proche",
    "Близкий": "Proche",
    "Бот уже прислал его в чат, в отдельную тему.": "Le bot l’a déjà envoyé dans le chat, dans un sujet à part.",
    "Ваш вариант": "Votre variante",
    "Ваше видео": "Votre vidéo",
    "Ваши слова голосом «{0}»": "Vos mots avec la voix « {0} »",
    "Ветер в волосах": "Vent dans les cheveux",
    "вид {0}": "apparence {0}",
    "видео": "vidéo",
    "Видео говорит": "La vidéo parle",
    "Видео из аудио": "Vidéo à partir d’un audio",
    "Видео не прошло проверку": "La vidéo n’a pas passé la vérification",
    "видео не создано": "la vidéo n’a pas été créée",
    "Видео повторится, пока звучит речь": "La vidéo se répète tant que la voix est audible",
    "Видео проверено": "Vidéo vérifiée",
    "Видео собрано": "Vidéo assemblée",
    "Видеооткрытка": "Carte vidéo",
    "Видеосообщение Telegram, до минуты": "Message vidéo Telegram, jusqu’à une minute",
    "Войдёт первая минута из {0}": "Seule la première minute sur {0} sera utilisée",
    "Выберите в ряду ниже": "Choisissez dans la rangée ci-dessous",
    "Выберите кадр": "Choisissez le cadrage",
    "Говорите: запись идёт": "Parlez : enregistrement en cours",
    "Говорящий кружок": "Message vidéo parlant",
    "голос {0}": "voix {0}",
    "Голос вашего варианта": "Voix de votre variante",
    "Голос заменён": "Voix remplacée",
    "Голос записан": "Voix enregistrée",
    "Голос наложен": "Voix ajoutée",
    "Голос персонажа": "Voix du personnage",
    "Горизонт.": "Horizontal",
    "Губы повторят вашу речь, до минуты": "Les lèvres suivront votre voix, jusqu’à une minute",
    "Губы синхронизированы": "Lèvres synchronisées",
    "Движение сгенерирует модель STEOS": "Le mouvement est généré par le modèle STEOS",
    "Для ленты": "Pour le fil",
    "Для Reels, Shorts и сторис": "Pour Reels, Shorts et stories",
    "Для YouTube и экрана": "Pour YouTube et l’écran",
    "до 1:00": "jusqu’à 1:00",
    "Доброе утро": "Bonjour",
    "за видео": "par vidéo",
    "за кружок": "par vidéo ronde",
    "Загрузите видео с лицом": "Importez une vidéo avec un visage",
    "Загрузите фото с лицом": "Importez une photo avec un visage",
    "Закончите запись": "Terminez l’enregistrement",
    "Закончите съёмку": "Terminez la prise de vue",
    "Заменить аудио": "Remplacer l’audio",
    "Заменить видео": "Remplacer la vidéo",
    "Записываем голос": "Enregistrement de la voix",
    "Запишите или загрузите речь": "Enregistrez ou importez la voix",
    "Зациклить": "En boucle",
    "Звук сгенерирует модель STEOS": "Le son est généré par le modèle STEOS",
    "из кружка": "de la vidéo ronde",
    "из этого кружка": "de cette vidéo ronde",
    "Изменить текст": "Modifier le texte",
    "Кадр готов": "Cadrage prêt",
    "Кадрируем в кружок": "Cadrage en vidéo ronde",
    "Кадрируем видео": "Cadrage de la vidéo",
    "Как в видео": "Comme dans la vidéo",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "Comment animer la photo ? Par exemple : cligne des yeux, sourit, tourne la tête",
    "Кольцо": "Anneau",
    "кружок": "vidéo ronde",
    "Кружок из аудио": "Message vidéo depuis un audio",
    "кружок не создан": "la vidéo ronde n’a pas été créée",
    "Кружок собран": "Vidéo ronde assemblée",
    "Кто говорит?": "Qui parle ?",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "Le visage n’était pas visible, la voix a donc été ajoutée sans synchronisation labiale.",
    "Лица не видно: голос наложим без подгонки губ": "Le visage n’est pas visible : nous ajouterons la voix sans synchronisation labiale",
    "Лицо в кадре, из длинного выберете минуту": "Visage dans le cadre ; dans une longue vidéo, vous choisirez une minute",
    "Лицо крупно и смотрит в камеру": "Visage en gros plan, regardant la caméra",
    "максимум минута": "une minute maximum",
    "Матрица": "Matrice",
    "Микрофон недоступен, запись имитируется": "Micro indisponible, l’enregistrement est simulé",
    "Минимум {0} символов": "Au moins {0} caractères",
    "можно своё фото или видео": "vous pouvez utiliser votre photo ou vidéo",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "Vous pouvez quitter l’écran : le bot enverra la vidéo terminée dans le chat.",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "Vous pouvez quitter l’écran : le bot enverra la vidéo ronde terminée dans le chat.",
    "Мой голос · клон": "Ma voix · clone",
    "Моргает и улыбается": "Cligne des yeux et sourit",
    "Морф": "Morph",
    "Мягкое свечение, как в голосовом режиме": "Lueur douce, comme en mode vocal",
    "на видео": "sur la vidéo",
    "на кружке": "sur la vidéo ronde",
    "Наезд камеры": "Travelling avant",
    "Накладываем голос на видео": "Ajout de la voix à la vidéo",
    "Написать текстом": "Écrire en texte",
    "Напишите, что скажет": "Écrivez ce qui sera dit",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "Par exemple : salut, bon lundi, que la semaine soit légère",
    "Не больше {0} знаков": "Pas plus de {0} caractères",
    "Не получилось собрать видео": "Impossible d’assembler la vidéo",
    "Не получилось собрать кружок": "Impossible d’assembler la vidéo ronde",
    "не скажет: нужен человек": "ne peut pas parler : il faut une personne",
    "Новые слова": "Nouveaux mots",
    "Новый год": "Nouvel An",
    "Оживляем персонажа": "Animation du personnage",
    "Оживляем фото": "Animation de la photo",
    "Оставить мою речь": "Garder ma voix",
    "Осциллограф на зелёном экране": "Oscilloscope sur écran vert",
    "Падающие символы": "Symboles qui tombent",
    "Переливающаяся капля меняет форму": "Une goutte chatoyante change de forme",
    "Персонаж ожил": "Le personnage est animé",
    "Плавная лента звука": "Un ruban sonore fluide",
    "Поворот головы": "Rotation de la tête",
    "Проверяем аудио": "Vérification de l’audio",
    "Проверяем видео": "Vérification de la vidéo",
    "Проверяем текст": "Vérification du texte",
    "Проиграть кружок": "Lire la vidéo ronde",
    "Просто так": "Juste comme ça",
    "Пульс": "Pulsation",
    "Расходящиеся круги": "Cercles qui s’élargissent",
    "Ретро": "Rétro",
    "Речь голосом: запись или файл": "Voix : enregistrement ou fichier",
    "Рисуем анимацию звука": "Dessin de l’animation sonore",
    "С днём рождения": "Joyeux anniversaire",
    "С понедельником": "Bon lundi",
    "Свадьба": "Mariage",
    "своя речь": "voix d’origine",
    "Своя речь из видео": "Voix d’origine de la vidéo",
    "Сделать видео": "Faire une vidéo",
    "Синхронизируем губы": "Synchronisation des lèvres",
    "Слова и голос как в видео": "Mots et voix comme dans la vidéo",
    "Слова и голос как в ролике": "Mots et voix comme dans le clip",
    "Смеётся": "Rit",
    "Собираем видео": "Assemblage de la vidéo",
    "Собираем кружок": "Assemblage de la vidéo ronde",
    "Создаём кружок": "Création de la vidéo ronde en cours",
    "стиль {0}": "style {0}",
    "Стиль анимации": "Style d’animation",
    "Стиль шаблона": "Style du modèle",
    "Столбики уровня звука": "Barres de niveau sonore",
    "Стрим": "Stream",
    "Основной": "Principal",
    "Сфера": "Sphère",
    "Текст не прошёл проверку": "Le texte n’a pas passé la vérification",
    "Текст проверен": "Texte vérifié",
    "Только для этого кружка": "Uniquement pour cette vidéo ronde",
    "Тут откроется тема чата, куда бот прислал видео": "Ici s’ouvrira le sujet du chat où le bot a envoyé la vidéo",
    "Тут откроется тема чата, куда бот прислал кружок": "Ici s’ouvrira le sujet du chat où le bot a envoyé la vidéo ronde",
    "Удалить из кружка": "Retirer de la vidéo ronde",
    "Феррожидкость": "Ferrofluide",
    "Фон на месте": "Arrière-plan fixe",
    "Формат задаёт шаблон": "Le modèle définit le format",
    "Фото говорит": "La photo parle",
    "Фото ожило": "La photo est animée",
    "Чего не должно": "Ce qui ne doit pas arriver",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "Que ne doit-il pas y avoir dans le cadre ? Par exemple : des mains en trop, un visage déformé",
    "Чёрная магнитная жидкость с шипами": "Liquide magnétique noir à pointes",
    "Читаем аудио": "Lecture de l’audio",
    "Что вы скажете? {0}": "Que direz-vous ? {0}",
    "Что звучит вокруг? Дождь, город, костёр": "Qu’entend-on autour ? Pluie, ville, feu de camp",
    "Что прозвучит? {0}": "Qu’entendra-t-on ? {0}",
    "Что происходит": "Ce qui se passe",
    "Что скажет": "Ce qui sera dit",
    "Что скажет {0}? {1}": "Que dira {0} ? {1}",
    "Что скажет герой? {0}": "Que dira le héros ? {0}",
    "Что скажет человек в кадре? {0}": "Que dira la personne à l’image ? {0}"
  },
  "pt": {
    "· кадр применится ко всему видео": "· o enquadramento será aplicado a todo o vídeo",
    "23 Февраля": "23 de fevereiro",
    "8 Марта": "8 de março",
    "Анимация готова": "Animação pronta",
    "Анимация оживёт под ваш звук": "A animação ganhará vida com o seu som",
    "аудио {0}": "áudio {0}",
    "Аудио не прошло проверку": "O áudio não passou na verificação",
    "Аудио проверено": "Áudio verificado",
    "Аудио прочитано": "Áudio lido",
    "Без изменений": "Sem alterações",
    "Без искажений": "Sem distorções",
    "Без лишних рук": "Sem mãos extras",
    "Без надписей": "Sem texto",
    "Без политики и запрещённых тем": "Sem política nem temas proibidos",
    "Бесконечное зеркало со светодиодами": "Espelho infinito com LEDs",
    "близкий": "pessoa próxima",
    "Близкий": "Pessoa próxima",
    "Бот уже прислал его в чат, в отдельную тему.": "O bot já o enviou para o chat, num tópico separado.",
    "Ваш вариант": "Sua variante",
    "Ваше видео": "Seu vídeo",
    "Ваши слова голосом «{0}»": "Suas palavras com a voz «{0}»",
    "Ветер в волосах": "Vento no cabelo",
    "вид {0}": "aparência {0}",
    "видео": "vídeo",
    "Видео говорит": "Vídeo fala",
    "Видео из аудио": "Vídeo a partir de áudio",
    "Видео не прошло проверку": "O vídeo não passou na verificação",
    "видео не создано": "o vídeo não foi criado",
    "Видео повторится, пока звучит речь": "O vídeo vai repetir enquanto a fala toca",
    "Видео проверено": "Vídeo verificado",
    "Видео собрано": "Vídeo montado",
    "Видеооткрытка": "Cartão em vídeo",
    "Видеосообщение Telegram, до минуты": "Mensagem de vídeo do Telegram, até um minuto",
    "Войдёт первая минута из {0}": "Será usado o primeiro minuto de {0}",
    "Выберите в ряду ниже": "Escolha na fila abaixo",
    "Выберите кадр": "Escolha o enquadramento",
    "Говорите: запись идёт": "Fale: a gravar",
    "Говорящий кружок": "Mensagem de vídeo falante",
    "голос {0}": "voz {0}",
    "Голос вашего варианта": "Voz da sua variante",
    "Голос заменён": "Voz substituída",
    "Голос записан": "Voz gravada",
    "Голос наложен": "Voz sobreposta",
    "Голос персонажа": "Voz do personagem",
    "Горизонт.": "Horizontal",
    "Губы повторят вашу речь, до минуты": "Os lábios vão seguir a sua fala, até um minuto",
    "Губы синхронизированы": "Lábios sincronizados",
    "Движение сгенерирует модель STEOS": "O movimento é gerado pelo modelo STEOS",
    "Для ленты": "Para o feed",
    "Для Reels, Shorts и сторис": "Para Reels, Shorts e stories",
    "Для YouTube и экрана": "Para YouTube e ecrã",
    "до 1:00": "até 1:00",
    "Доброе утро": "Bom dia",
    "за видео": "por vídeo",
    "за кружок": "por vídeo circular",
    "Загрузите видео с лицом": "Carregue um vídeo com um rosto",
    "Загрузите фото с лицом": "Carregue uma foto com um rosto",
    "Закончите запись": "Termine a gravação",
    "Закончите съёмку": "Termine a filmagem",
    "Заменить аудио": "Substituir áudio",
    "Заменить видео": "Substituir vídeo",
    "Записываем голос": "A gravar a voz",
    "Запишите или загрузите речь": "Grave ou carregue a fala",
    "Зациклить": "Repetir em loop",
    "Звук сгенерирует модель STEOS": "O som é gerado pelo modelo STEOS",
    "из кружка": "do vídeo circular",
    "из этого кружка": "deste vídeo circular",
    "Изменить текст": "Editar texto",
    "Кадр готов": "Enquadramento pronto",
    "Кадрируем в кружок": "A enquadrar em vídeo circular",
    "Кадрируем видео": "A enquadrar o vídeo",
    "Как в видео": "Como no vídeo",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "Como dar vida à foto? Por exemplo: pisca, sorri, vira a cabeça",
    "Кольцо": "Anel",
    "кружок": "vídeo circular",
    "Кружок из аудио": "Mensagem de vídeo de um áudio",
    "кружок не создан": "o vídeo circular não foi criado",
    "Кружок собран": "Vídeo circular montado",
    "Кто говорит?": "Quem fala?",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "O rosto não estava visível no enquadramento, por isso a voz foi sobreposta sem sincronizar os lábios.",
    "Лица не видно: голос наложим без подгонки губ": "O rosto não está visível: vamos sobrepor a voz sem sincronizar os lábios",
    "Лицо в кадре, из длинного выберете минуту": "Rosto no enquadramento; de um vídeo longo escolherá um minuto",
    "Лицо крупно и смотрит в камеру": "Rosto em grande plano e a olhar para a câmara",
    "максимум минута": "um minuto no máximo",
    "Матрица": "Matriz",
    "Микрофон недоступен, запись имитируется": "Microfone indisponível, a gravação é simulada",
    "Минимум {0} символов": "Mínimo de {0} caracteres",
    "можно своё фото или видео": "pode usar a sua própria foto ou vídeo",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "Pode sair do ecrã: o bot vai enviar o vídeo pronto para o chat.",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "Pode sair do ecrã: o bot vai enviar o vídeo circular pronto para o chat.",
    "Мой голос · клон": "Minha voz · clone",
    "Моргает и улыбается": "Pisca e sorri",
    "Морф": "Morph",
    "Мягкое свечение, как в голосовом режиме": "Brilho suave, como no modo de voz",
    "на видео": "no vídeo",
    "на кружке": "no vídeo circular",
    "Наезд камеры": "Aproximação da câmara",
    "Накладываем голос на видео": "A sobrepor a voz ao vídeo",
    "Написать текстом": "Escrever em texto",
    "Напишите, что скажет": "Escreva o que vai dizer",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "Por exemplo: olá, boa segunda-feira, que a semana seja leve",
    "Не больше {0} знаков": "No máximo {0} caracteres",
    "Не получилось собрать видео": "Não foi possível montar o vídeo",
    "Не получилось собрать кружок": "Não foi possível montar o vídeo circular",
    "не скажет: нужен человек": "não pode falar: é preciso uma pessoa",
    "Новые слова": "Novas palavras",
    "Новый год": "Ano Novo",
    "Оживляем персонажа": "A dar vida ao personagem",
    "Оживляем фото": "A dar vida à foto",
    "Оставить мою речь": "Manter a minha fala",
    "Осциллограф на зелёном экране": "Osciloscópio em ecrã verde",
    "Падающие символы": "Símbolos a cair",
    "Переливающаяся капля меняет форму": "Uma gota iridescente muda de forma",
    "Персонаж ожил": "O personagem ganhou vida",
    "Плавная лента звука": "Uma fita de som suave",
    "Поворот головы": "Virar a cabeça",
    "Проверяем аудио": "A verificar o áudio",
    "Проверяем видео": "A verificar o vídeo",
    "Проверяем текст": "A verificar o texto",
    "Проиграть кружок": "Reproduzir o vídeo circular",
    "Просто так": "Só porque sim",
    "Пульс": "Pulso",
    "Расходящиеся круги": "Círculos que se expandem",
    "Ретро": "Retro",
    "Речь голосом: запись или файл": "Fala por voz: gravação ou ficheiro",
    "Рисуем анимацию звука": "A desenhar a animação do som",
    "С днём рождения": "Feliz aniversário",
    "С понедельником": "Boa segunda-feira",
    "Свадьба": "Casamento",
    "своя речь": "fala própria",
    "Своя речь из видео": "Fala própria do vídeo",
    "Сделать видео": "Fazer vídeo",
    "Синхронизируем губы": "A sincronizar os lábios",
    "Слова и голос как в видео": "Palavras e voz como no vídeo",
    "Слова и голос как в ролике": "Palavras e voz como no clipe",
    "Смеётся": "Ri-se",
    "Собираем видео": "A montar o vídeo",
    "Собираем кружок": "A montar o vídeo circular",
    "Создаём кружок": "A criar vídeo circular",
    "стиль {0}": "estilo {0}",
    "Стиль анимации": "Estilo de animação",
    "Стиль шаблона": "Estilo do modelo",
    "Столбики уровня звука": "Barras de nível de som",
    "Стрим": "Stream",
    "Основной": "Principal",
    "Сфера": "Esfera",
    "Текст не прошёл проверку": "O texto não passou na verificação",
    "Текст проверен": "Texto verificado",
    "Только для этого кружка": "Só para este vídeo circular",
    "Тут откроется тема чата, куда бот прислал видео": "Aqui vai abrir o tópico do chat onde o bot enviou o vídeo",
    "Тут откроется тема чата, куда бот прислал кружок": "Aqui vai abrir o tópico do chat onde o bot enviou o vídeo circular",
    "Удалить из кружка": "Remover do vídeo circular",
    "Феррожидкость": "Ferrofluido",
    "Фон на месте": "Fundo fixo",
    "Формат задаёт шаблон": "O modelo define o formato",
    "Фото говорит": "Foto fala",
    "Фото ожило": "A foto ganhou vida",
    "Чего не должно": "O que não deve acontecer",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "O que não deve aparecer? Por exemplo: mãos extras, distorção do rosto",
    "Чёрная магнитная жидкость с шипами": "Líquido magnético preto com espinhos",
    "Читаем аудио": "A ler o áudio",
    "Что вы скажете? {0}": "O que vai dizer? {0}",
    "Что звучит вокруг? Дождь, город, костёр": "O que se ouve à volta? Chuva, cidade, fogueira",
    "Что прозвучит? {0}": "O que vai soar? {0}",
    "Что происходит": "O que acontece",
    "Что скажет": "O que vai dizer",
    "Что скажет {0}? {1}": "O que {0} vai dizer? {1}",
    "Что скажет герой? {0}": "O que o herói vai dizer? {0}",
    "Что скажет человек в кадре? {0}": "O que a pessoa no enquadramento vai dizer? {0}"
  },
  "tr": {
    "· кадр применится ко всему видео": "· kadraj tüm videoya uygulanır",
    "23 Февраля": "23 Şubat",
    "8 Марта": "8 Mart",
    "Анимация готова": "Animasyon hazır",
    "Анимация оживёт под ваш звук": "Animasyon sesinize göre canlanacak",
    "аудио {0}": "ses {0}",
    "Аудио не прошло проверку": "Ses kontrolden geçmedi",
    "Аудио проверено": "Ses kontrol edildi",
    "Аудио прочитано": "Ses okundu",
    "Без изменений": "Değişiklik yok",
    "Без искажений": "Bozulma yok",
    "Без лишних рук": "Fazladan el yok",
    "Без надписей": "Metinsiz",
    "Без политики и запрещённых тем": "Siyaset ve yasaklı konular yok",
    "Бесконечное зеркало со светодиодами": "LED’li sonsuzluk aynası",
    "близкий": "yakın",
    "Близкий": "Yakın",
    "Бот уже прислал его в чат, в отдельную тему.": "Bot onu sohbete, ayrı bir konuya zaten gönderdi.",
    "Ваш вариант": "Varyantınız",
    "Ваше видео": "Videonuz",
    "Ваши слова голосом «{0}»": "Sözleriniz «{0}» sesiyle",
    "Ветер в волосах": "Saçlarda rüzgâr",
    "вид {0}": "görünüm {0}",
    "видео": "video",
    "Видео говорит": "Video konuşuyor",
    "Видео из аудио": "Sesten video",
    "Видео не прошло проверку": "Video kontrolden geçmedi",
    "видео не создано": "video oluşturulmadı",
    "Видео повторится, пока звучит речь": "Konuşma sürdükçe video tekrarlanır",
    "Видео проверено": "Video kontrol edildi",
    "Видео собрано": "Video birleştirildi",
    "Видеооткрытка": "Video kartpostal",
    "Видеосообщение Telegram, до минуты": "Telegram video mesajı, bir dakikaya kadar",
    "Войдёт первая минута из {0}": "{0} içinden ilk dakika kullanılacak",
    "Выберите в ряду ниже": "Aşağıdaki sıradan seçin",
    "Выберите кадр": "Kadrajı seçin",
    "Говорите: запись идёт": "Konuşun: kayıt sürüyor",
    "Говорящий кружок": "Konuşan görüntülü mesaj",
    "голос {0}": "ses {0}",
    "Голос вашего варианта": "Varyantınızın sesi",
    "Голос заменён": "Ses değiştirildi",
    "Голос записан": "Ses kaydedildi",
    "Голос наложен": "Ses eklendi",
    "Голос персонажа": "Karakter sesi",
    "Горизонт.": "Yatay",
    "Губы повторят вашу речь, до минуты": "Dudaklar konuşmanızı takip eder, bir dakikaya kadar",
    "Губы синхронизированы": "Dudaklar senkronize edildi",
    "Движение сгенерирует модель STEOS": "Hareketi STEOS modeli oluşturur",
    "Для ленты": "Akış için",
    "Для Reels, Shorts и сторис": "Reels, Shorts ve hikâyeler için",
    "Для YouTube и экрана": "YouTube ve ekran için",
    "до 1:00": "1:00’a kadar",
    "Доброе утро": "Günaydın",
    "за видео": "video başına",
    "за кружок": "yuvarlak video başına",
    "Загрузите видео с лицом": "Yüz içeren bir video yükleyin",
    "Загрузите фото с лицом": "Yüz içeren bir fotoğraf yükleyin",
    "Закончите запись": "Kaydı bitirin",
    "Закончите съёмку": "Çekimi bitirin",
    "Заменить аудио": "Sesi değiştir",
    "Заменить видео": "Videoyu değiştir",
    "Записываем голос": "Ses kaydediliyor",
    "Запишите или загрузите речь": "Konuşmayı kaydedin veya yükleyin",
    "Зациклить": "Döngüye al",
    "Звук сгенерирует модель STEOS": "Sesi STEOS modeli oluşturur",
    "из кружка": "yuvarlak videodan",
    "из этого кружка": "bu yuvarlak videodan",
    "Изменить текст": "Metni düzenle",
    "Кадр готов": "Kadraj hazır",
    "Кадрируем в кружок": "Yuvarlak videoya kadrajlanıyor",
    "Кадрируем видео": "Video kadrajlanıyor",
    "Как в видео": "Videodaki gibi",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "Fotoğraf nasıl canlansın? Örneğin: göz kırpar, gülümser, başını çevirir",
    "Кольцо": "Halka",
    "кружок": "yuvarlak video",
    "Кружок из аудио": "Sesten görüntülü mesaj",
    "кружок не создан": "yuvarlak video oluşturulmadı",
    "Кружок собран": "Yuvarlak video birleştirildi",
    "Кто говорит?": "Kim konuşuyor?",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "Yüz kadrajda görünmüyordu, bu yüzden ses dudak senkronu olmadan eklendi.",
    "Лица не видно: голос наложим без подгонки губ": "Yüz görünmüyor: sesi dudak senkronu olmadan ekleyeceğiz",
    "Лицо в кадре, из длинного выберете минуту": "Yüz kadrajda olsun; uzun videodan bir dakika seçeceksiniz",
    "Лицо крупно и смотрит в камеру": "Yüz yakın planda ve kameraya bakıyor",
    "максимум минута": "en fazla bir dakika",
    "Матрица": "Matris",
    "Микрофон недоступен, запись имитируется": "Mikrofon kullanılamıyor, kayıt taklit ediliyor",
    "Минимум {0} символов": "En az {0} karakter",
    "можно своё фото или видео": "kendi fotoğrafınızı veya videonuzu kullanabilirsiniz",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "Ekrandan çıkabilirsiniz: bot hazır videoyu sohbete gönderecek.",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "Ekrandan çıkabilirsiniz: bot hazır yuvarlak videoyu sohbete gönderecek.",
    "Мой голос · клон": "Sesim · klon",
    "Моргает и улыбается": "Göz kırpıp gülümsüyor",
    "Морф": "Morf",
    "Мягкое свечение, как в голосовом режиме": "Sesli moddaki gibi yumuşak ışıltı",
    "на видео": "videoda",
    "на кружке": "yuvarlak videoda",
    "Наезд камеры": "Kamera yaklaşması",
    "Накладываем голос на видео": "Ses videoya ekleniyor",
    "Написать текстом": "Metin olarak yaz",
    "Напишите, что скажет": "Ne söyleyeceğini yazın",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "Örneğin: merhaba, iyi pazartesiler, haftan kolay geçsin",
    "Не больше {0} знаков": "En fazla {0} karakter",
    "Не получилось собрать видео": "Video birleştirilemedi",
    "Не получилось собрать кружок": "Yuvarlak video birleştirilemedi",
    "не скажет: нужен человек": "konuşamaz: bir insan gerekli",
    "Новые слова": "Yeni sözler",
    "Новый год": "Yılbaşı",
    "Оживляем персонажа": "Karakter canlandırılıyor",
    "Оживляем фото": "Fotoğraf canlandırılıyor",
    "Оставить мою речь": "Konuşmamı koru",
    "Осциллограф на зелёном экране": "Yeşil ekranda osiloskop",
    "Падающие символы": "Düşen semboller",
    "Переливающаяся капля меняет форму": "Yanardöner bir damla şekil değiştirir",
    "Персонаж ожил": "Karakter canlandı",
    "Плавная лента звука": "Akıcı bir ses şeridi",
    "Поворот головы": "Baş çevirme",
    "Проверяем аудио": "Ses kontrol ediliyor",
    "Проверяем видео": "Video kontrol ediliyor",
    "Проверяем текст": "Metin kontrol ediliyor",
    "Проиграть кружок": "Yuvarlak videoyu oynat",
    "Просто так": "Öylesine",
    "Пульс": "Nabız",
    "Расходящиеся круги": "Yayılan halkalar",
    "Ретро": "Retro",
    "Речь голосом: запись или файл": "Sesli konuşma: kayıt veya dosya",
    "Рисуем анимацию звука": "Ses animasyonu çiziliyor",
    "С днём рождения": "Doğum günün kutlu olsun",
    "С понедельником": "İyi pazartesiler",
    "Свадьба": "Düğün",
    "своя речь": "kendi konuşması",
    "Своя речь из видео": "Videodaki kendi konuşmanız",
    "Сделать видео": "Video yap",
    "Синхронизируем губы": "Dudaklar senkronize ediliyor",
    "Слова и голос как в видео": "Sözler ve ses videodaki gibi",
    "Слова и голос как в ролике": "Sözler ve ses klipteki gibi",
    "Смеётся": "Gülüyor",
    "Собираем видео": "Video birleştiriliyor",
    "Собираем кружок": "Yuvarlak video birleştiriliyor",
    "Создаём кружок": "Yuvarlak video oluşturuluyor",
    "стиль {0}": "stil {0}",
    "Стиль анимации": "Animasyon stili",
    "Стиль шаблона": "Şablon stili",
    "Столбики уровня звука": "Ses seviyesi çubukları",
    "Стрим": "Yayın",
    "Основной": "Varsayılan",
    "Сфера": "Küre",
    "Текст не прошёл проверку": "Metin kontrolden geçmedi",
    "Текст проверен": "Metin kontrol edildi",
    "Только для этого кружка": "Yalnızca bu yuvarlak video için",
    "Тут откроется тема чата, куда бот прислал видео": "Botun videoyu gönderdiği sohbet konusu burada açılır",
    "Тут откроется тема чата, куда бот прислал кружок": "Botun yuvarlak videoyu gönderdiği sohbet konusu burada açılır",
    "Удалить из кружка": "Yuvarlak videodan kaldır",
    "Феррожидкость": "Ferroakışkan",
    "Фон на месте": "Arka plan sabit",
    "Формат задаёт шаблон": "Biçimi şablon belirler",
    "Фото говорит": "Fotoğraf konuşuyor",
    "Фото ожило": "Fotoğraf canlandı",
    "Чего не должно": "Olmaması gereken",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "Kadrajda ne olmamalı? Örneğin: fazladan eller, yüz bozulmaları",
    "Чёрная магнитная жидкость с шипами": "Dikenli siyah manyetik sıvı",
    "Читаем аудио": "Ses okunuyor",
    "Что вы скажете? {0}": "Ne söyleyeceksiniz? {0}",
    "Что звучит вокруг? Дождь, город, костёр": "Etrafta ne duyuluyor? Yağmur, şehir, kamp ateşi",
    "Что прозвучит? {0}": "Ne duyulacak? {0}",
    "Что происходит": "Ne oluyor",
    "Что скажет": "Ne söyleyecek",
    "Что скажет {0}? {1}": "{0} ne söyleyecek? {1}",
    "Что скажет герой? {0}": "Kahraman ne söyleyecek? {0}",
    "Что скажет человек в кадре? {0}": "Kadrajdaki kişi ne söyleyecek? {0}"
  },
  "kk": {
    "· кадр применится ко всему видео": "· кадр бүкіл бейнеге қолданылады",
    "23 Февраля": "23 ақпан",
    "8 Марта": "8 наурыз",
    "Анимация готова": "Анимация дайын",
    "Анимация оживёт под ваш звук": "Анимация дыбысыңызға қарай жанданады",
    "аудио {0}": "аудио {0}",
    "Аудио не прошло проверку": "Аудио тексеруден өтпеді",
    "Аудио проверено": "Аудио тексерілді",
    "Аудио прочитано": "Аудио оқылды",
    "Без изменений": "Өзгеріссіз",
    "Без искажений": "Бұрмалаусыз",
    "Без лишних рук": "Артық қолсыз",
    "Без надписей": "Жазусыз",
    "Без политики и запрещённых тем": "Саясатсыз және тыйым салынған тақырыптарсыз",
    "Бесконечное зеркало со светодиодами": "Жарықдиодты шексіз айна",
    "близкий": "жақын адам",
    "Близкий": "Жақын адам",
    "Бот уже прислал его в чат, в отдельную тему.": "Бот оны чатқа, жеке тақырыпқа жіберіп қойды.",
    "Ваш вариант": "Сіздің нұсқаңыз",
    "Ваше видео": "Сіздің бейнеңіз",
    "Ваши слова голосом «{0}»": "Сіздің сөздеріңіз «{0}» дауысымен",
    "Ветер в волосах": "Шаштағы жел",
    "вид {0}": "көрініс {0}",
    "видео": "бейне",
    "Видео говорит": "Бейне сөйлейді",
    "Видео из аудио": "Аудиодан бейне",
    "Видео не прошло проверку": "Бейне тексеруден өтпеді",
    "видео не создано": "бейне жасалмады",
    "Видео повторится, пока звучит речь": "Сөз естіліп тұрғанда бейне қайталанады",
    "Видео проверено": "Бейне тексерілді",
    "Видео собрано": "Бейне жиналды",
    "Видеооткрытка": "Бейнеашықхат",
    "Видеосообщение Telegram, до минуты": "Telegram бейнехабарламасы, бір минутқа дейін",
    "Войдёт первая минута из {0}": "{0} ішінен бірінші минут алынады",
    "Выберите в ряду ниже": "Төмендегі қатардан таңдаңыз",
    "Выберите кадр": "Кадрды таңдаңыз",
    "Говорите: запись идёт": "Сөйлеңіз: жазылып жатыр",
    "Говорящий кружок": "Сөйлейтін бейнехабар",
    "голос {0}": "дауыс {0}",
    "Голос вашего варианта": "Нұсқаңыздың дауысы",
    "Голос заменён": "Дауыс ауыстырылды",
    "Голос записан": "Дауыс жазылды",
    "Голос наложен": "Дауыс қосылды",
    "Голос персонажа": "Кейіпкер дауысы",
    "Горизонт.": "Көлденең",
    "Губы повторят вашу речь, до минуты": "Ерін сөзіңізді қайталайды, бір минутқа дейін",
    "Губы синхронизированы": "Ерін үйлестірілді",
    "Движение сгенерирует модель STEOS": "Қозғалысты STEOS моделі жасайды",
    "Для ленты": "Лента үшін",
    "Для Reels, Shorts и сторис": "Reels, Shorts және сторис үшін",
    "Для YouTube и экрана": "YouTube және экран үшін",
    "до 1:00": "1:00 дейін",
    "Доброе утро": "Қайырлы таң",
    "за видео": "бейне үшін",
    "за кружок": "дөңгелек бейне үшін",
    "Загрузите видео с лицом": "Бет көрінетін бейне жүктеңіз",
    "Загрузите фото с лицом": "Бет көрінетін фото жүктеңіз",
    "Закончите запись": "Жазуды аяқтаңыз",
    "Закончите съёмку": "Түсіруді аяқтаңыз",
    "Заменить аудио": "Аудионы ауыстыру",
    "Заменить видео": "Бейнені ауыстыру",
    "Записываем голос": "Дауысты жазып жатырмыз",
    "Запишите или загрузите речь": "Сөзді жазыңыз немесе жүктеңіз",
    "Зациклить": "Қайталау",
    "Звук сгенерирует модель STEOS": "Дыбысты STEOS моделі жасайды",
    "из кружка": "дөңгелек бейнеден",
    "из этого кружка": "осы дөңгелек бейнеден",
    "Изменить текст": "Мәтінді өзгерту",
    "Кадр готов": "Кадр дайын",
    "Кадрируем в кружок": "Дөңгелек бейнеге кадрлап жатырмыз",
    "Кадрируем видео": "Бейнені кадрлап жатырмыз",
    "Как в видео": "Бейнедегідей",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "Суретті қалай жандандыру керек? Мысалы: көзін жыпылықтатады, күледі, басын бұрады",
    "Кольцо": "Сақина",
    "кружок": "дөңгелек бейне",
    "Кружок из аудио": "Аудиодан бейнехабар",
    "кружок не создан": "дөңгелек бейне жасалмады",
    "Кружок собран": "Дөңгелек бейне жиналды",
    "Кто говорит?": "Кім сөйлейді?",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "Кадрда бет көрінбеді, сондықтан дауыс ерін үйлесімінсіз қосылды.",
    "Лица не видно: голос наложим без подгонки губ": "Бет көрінбейді: дауысты ерін үйлесімінсіз қосамыз",
    "Лицо в кадре, из длинного выберете минуту": "Бет кадрда болсын, ұзын бейнеден бір минут таңдайсыз",
    "Лицо крупно и смотрит в камеру": "Бет ірі планда және камераға қарап тұр",
    "максимум минута": "ең көбі бір минут",
    "Матрица": "Матрица",
    "Микрофон недоступен, запись имитируется": "Микрофон қолжетімсіз, жазу имитацияланады",
    "Минимум {0} символов": "Кемінде {0} таңба",
    "можно своё фото или видео": "өз фотоңызды немесе бейнеңізді қолдануға болады",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "Экраннан шығуға болады: бот дайын бейнені чатқа жібереді.",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "Экраннан шығуға болады: бот дайын дөңгелек бейнені чатқа жібереді.",
    "Мой голос · клон": "Менің дауысым · клон",
    "Моргает и улыбается": "Көзін жыпылықтатып, күледі",
    "Морф": "Морф",
    "Мягкое свечение, как в голосовом режиме": "Дауыстық режимдегідей жұмсақ жарық",
    "на видео": "бейнеде",
    "на кружке": "дөңгелек бейнеде",
    "Наезд камеры": "Камераның жақындауы",
    "Накладываем голос на видео": "Дауысты бейнеге қосып жатырмыз",
    "Написать текстом": "Мәтінмен жазу",
    "Напишите, что скажет": "Не айтатынын жазыңыз",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "Мысалы: сәлем, дүйсенбің құтты болсын, апта жеңіл өтсін",
    "Не больше {0} знаков": "{0} таңбадан аспасын",
    "Не получилось собрать видео": "Бейнені жинау мүмкін болмады",
    "Не получилось собрать кружок": "Дөңгелек бейнені жинау мүмкін болмады",
    "не скажет: нужен человек": "сөйлей алмайды: адам керек",
    "Новые слова": "Жаңа сөздер",
    "Новый год": "Жаңа жыл",
    "Оживляем персонажа": "Кейіпкерді жандандырып жатырмыз",
    "Оживляем фото": "Фотоны жандандырып жатырмыз",
    "Оставить мою речь": "Өз сөзімді қалдыру",
    "Осциллограф на зелёном экране": "Жасыл экрандағы осциллограф",
    "Падающие символы": "Құлап жатқан символдар",
    "Переливающаяся капля меняет форму": "Құбылмалы тамшы пішінін өзгертеді",
    "Персонаж ожил": "Кейіпкер жанданды",
    "Плавная лента звука": "Дыбыстың бірқалыпты таспасы",
    "Поворот головы": "Басты бұру",
    "Проверяем аудио": "Аудионы тексеріп жатырмыз",
    "Проверяем видео": "Бейнені тексеріп жатырмыз",
    "Проверяем текст": "Мәтінді тексеріп жатырмыз",
    "Проиграть кружок": "Дөңгелек бейнені ойнату",
    "Просто так": "Жай ғана",
    "Пульс": "Пульс",
    "Расходящиеся круги": "Таралатын шеңберлер",
    "Ретро": "Ретро",
    "Речь голосом: запись или файл": "Дауыспен сөйлеу: жазба немесе файл",
    "Рисуем анимацию звука": "Дыбыс анимациясын салып жатырмыз",
    "С днём рождения": "Туған күніңмен",
    "С понедельником": "Дүйсенбің құтты болсын",
    "Свадьба": "Үйлену той",
    "своя речь": "өз сөзі",
    "Своя речь из видео": "Бейнедегі өз сөзіңіз",
    "Сделать видео": "Бейне жасау",
    "Синхронизируем губы": "Ерінді үйлестіріп жатырмыз",
    "Слова и голос как в видео": "Сөздер мен дауыс бейнедегідей",
    "Слова и голос как в ролике": "Сөздер мен дауыс роликтегідей",
    "Смеётся": "Күледі",
    "Собираем видео": "Бейнені жинап жатырмыз",
    "Собираем кружок": "Дөңгелек бейнені жинап жатырмыз",
    "Создаём кружок": "Дөңгелек бейне жасалуда",
    "стиль {0}": "стиль {0}",
    "Стиль анимации": "Анимация стилі",
    "Стиль шаблона": "Үлгі стилі",
    "Столбики уровня звука": "Дыбыс деңгейінің бағаналары",
    "Стрим": "Стрим",
    "Основной": "Негізгі",
    "Сфера": "Сфера",
    "Текст не прошёл проверку": "Мәтін тексеруден өтпеді",
    "Текст проверен": "Мәтін тексерілді",
    "Только для этого кружка": "Тек осы дөңгелек бейне үшін",
    "Тут откроется тема чата, куда бот прислал видео": "Мұнда бот бейнені жіберген чат тақырыбы ашылады",
    "Тут откроется тема чата, куда бот прислал кружок": "Мұнда бот дөңгелек бейнені жіберген чат тақырыбы ашылады",
    "Удалить из кружка": "Дөңгелек бейнеден жою",
    "Феррожидкость": "Феррсұйықтық",
    "Фон на месте": "Фон орнында",
    "Формат задаёт шаблон": "Пішімді үлгі белгілейді",
    "Фото говорит": "Фото сөйлейді",
    "Фото ожило": "Фото жанданды",
    "Чего не должно": "Не болмауы керек",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "Кадрда не болмауы керек? Мысалы: артық қолдар, беттің бұрмалануы",
    "Чёрная магнитная жидкость с шипами": "Тікенді қара магниттік сұйықтық",
    "Читаем аудио": "Аудионы оқып жатырмыз",
    "Что вы скажете? {0}": "Не айтасыз? {0}",
    "Что звучит вокруг? Дождь, город, костёр": "Айналада не естіледі? Жаңбыр, қала, алау",
    "Что прозвучит? {0}": "Не естіледі? {0}",
    "Что происходит": "Не болып жатыр",
    "Что скажет": "Не айтады",
    "Что скажет {0}? {1}": "{0} не айтады? {1}",
    "Что скажет герой? {0}": "Кейіпкер не айтады? {0}",
    "Что скажет человек в кадре? {0}": "Кадрдағы адам не айтады? {0}"
  },
  "uk": {
    "· кадр применится ко всему видео": "· кадр застосується до всього відео",
    "23 Февраля": "23 лютого",
    "8 Марта": "8 березня",
    "Анимация готова": "Анімація готова",
    "Анимация оживёт под ваш звук": "Анімація оживе під ваш звук",
    "аудио {0}": "аудіо {0}",
    "Аудио не прошло проверку": "Аудіо не пройшло перевірку",
    "Аудио проверено": "Аудіо перевірено",
    "Аудио прочитано": "Аудіо прочитано",
    "Без изменений": "Без змін",
    "Без искажений": "Без спотворень",
    "Без лишних рук": "Без зайвих рук",
    "Без надписей": "Без написів",
    "Без политики и запрещённых тем": "Без політики та заборонених тем",
    "Бесконечное зеркало со светодиодами": "Нескінченне дзеркало зі світлодіодами",
    "близкий": "близька людина",
    "Близкий": "Близька людина",
    "Бот уже прислал его в чат, в отдельную тему.": "Бот уже надіслав його в чат, в окрему тему.",
    "Ваш вариант": "Ваш варіант",
    "Ваше видео": "Ваше відео",
    "Ваши слова голосом «{0}»": "Ваші слова голосом «{0}»",
    "Ветер в волосах": "Вітер у волоссі",
    "вид {0}": "вигляд {0}",
    "видео": "відео",
    "Видео говорит": "Відео говорить",
    "Видео из аудио": "Відео з аудіо",
    "Видео не прошло проверку": "Відео не пройшло перевірку",
    "видео не создано": "відео не створено",
    "Видео повторится, пока звучит речь": "Відео повторюватиметься, поки звучить мова",
    "Видео проверено": "Відео перевірено",
    "Видео собрано": "Відео зібрано",
    "Видеооткрытка": "Відеолистівка",
    "Видеосообщение Telegram, до минуты": "Відеоповідомлення Telegram, до хвилини",
    "Войдёт первая минута из {0}": "Увійде перша хвилина з {0}",
    "Выберите в ряду ниже": "Виберіть у ряду нижче",
    "Выберите кадр": "Виберіть кадр",
    "Говорите: запись идёт": "Говоріть: іде запис",
    "Говорящий кружок": "Відеоповідомлення, що говорить",
    "голос {0}": "голос {0}",
    "Голос вашего варианта": "Голос вашого варіанта",
    "Голос заменён": "Голос замінено",
    "Голос записан": "Голос записано",
    "Голос наложен": "Голос накладено",
    "Голос персонажа": "Голос персонажа",
    "Горизонт.": "Горизонт.",
    "Губы повторят вашу речь, до минуты": "Губи повторять вашу мову, до хвилини",
    "Губы синхронизированы": "Губи синхронізовано",
    "Движение сгенерирует модель STEOS": "Рух згенерує модель STEOS",
    "Для ленты": "Для стрічки",
    "Для Reels, Shorts и сторис": "Для Reels, Shorts та історій",
    "Для YouTube и экрана": "Для YouTube та екрана",
    "до 1:00": "до 1:00",
    "Доброе утро": "Доброго ранку",
    "за видео": "за відео",
    "за кружок": "за кружечок",
    "Загрузите видео с лицом": "Завантажте відео з обличчям",
    "Загрузите фото с лицом": "Завантажте фото з обличчям",
    "Закончите запись": "Завершіть запис",
    "Закончите съёмку": "Завершіть зйомку",
    "Заменить аудио": "Замінити аудіо",
    "Заменить видео": "Замінити відео",
    "Записываем голос": "Записуємо голос",
    "Запишите или загрузите речь": "Запишіть або завантажте мову",
    "Зациклить": "Зациклити",
    "Звук сгенерирует модель STEOS": "Звук згенерує модель STEOS",
    "из кружка": "з кружечка",
    "из этого кружка": "з цього кружечка",
    "Изменить текст": "Змінити текст",
    "Кадр готов": "Кадр готовий",
    "Кадрируем в кружок": "Кадруємо в кружечок",
    "Кадрируем видео": "Кадруємо відео",
    "Как в видео": "Як у відео",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "Як оживити знімок? Наприклад: кліпає, усміхається, повертає голову",
    "Кольцо": "Кільце",
    "кружок": "кружечок",
    "Кружок из аудио": "Відеоповідомлення з аудіо",
    "кружок не создан": "кружечок не створено",
    "Кружок собран": "Кружечок зібрано",
    "Кто говорит?": "Хто говорить?",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "Обличчя в кадрі не було видно, тому голос накладено без підгонки губ.",
    "Лица не видно: голос наложим без подгонки губ": "Обличчя не видно: накладемо голос без підгонки губ",
    "Лицо в кадре, из длинного выберете минуту": "Обличчя в кадрі, з довгого виберете хвилину",
    "Лицо крупно и смотрит в камеру": "Обличчя великим планом і дивиться в камеру",
    "максимум минута": "максимум хвилина",
    "Матрица": "Матриця",
    "Микрофон недоступен, запись имитируется": "Мікрофон недоступний, запис імітується",
    "Минимум {0} символов": "Мінімум {0} символів",
    "можно своё фото или видео": "можна своє фото або відео",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "Можна піти з екрана: бот надішле готове відео в чат.",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "Можна піти з екрана: бот надішле готовий кружечок у чат.",
    "Мой голос · клон": "Мій голос · клон",
    "Моргает и улыбается": "Кліпає й усміхається",
    "Морф": "Морф",
    "Мягкое свечение, как в голосовом режиме": "М’яке світіння, як у голосовому режимі",
    "на видео": "на відео",
    "на кружке": "на кружечку",
    "Наезд камеры": "Наїзд камери",
    "Накладываем голос на видео": "Накладаємо голос на відео",
    "Написать текстом": "Написати текстом",
    "Напишите, что скажет": "Напишіть, що скаже",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "Наприклад: привіт, з понеділком, хай тиждень буде легким",
    "Не больше {0} знаков": "Не більше {0} знаків",
    "Не получилось собрать видео": "Не вдалося зібрати відео",
    "Не получилось собрать кружок": "Не вдалося зібрати кружечок",
    "не скажет: нужен человек": "не скаже: потрібна людина",
    "Новые слова": "Нові слова",
    "Новый год": "Новий рік",
    "Оживляем персонажа": "Оживляємо персонажа",
    "Оживляем фото": "Оживляємо фото",
    "Оставить мою речь": "Залишити мою мову",
    "Осциллограф на зелёном экране": "Осцилограф на зеленому екрані",
    "Падающие символы": "Символи, що падають",
    "Переливающаяся капля меняет форму": "Мінлива крапля змінює форму",
    "Персонаж ожил": "Персонаж ожив",
    "Плавная лента звука": "Плавна стрічка звуку",
    "Поворот головы": "Поворот голови",
    "Проверяем аудио": "Перевіряємо аудіо",
    "Проверяем видео": "Перевіряємо відео",
    "Проверяем текст": "Перевіряємо текст",
    "Проиграть кружок": "Відтворити кружечок",
    "Просто так": "Просто так",
    "Пульс": "Пульс",
    "Расходящиеся круги": "Кола, що розходяться",
    "Ретро": "Ретро",
    "Речь голосом: запись или файл": "Мова голосом: запис або файл",
    "Рисуем анимацию звука": "Малюємо анімацію звуку",
    "С днём рождения": "З днем народження",
    "С понедельником": "З понеділком",
    "Свадьба": "Весілля",
    "своя речь": "власна мова",
    "Своя речь из видео": "Власна мова з відео",
    "Сделать видео": "Зробити відео",
    "Синхронизируем губы": "Синхронізуємо губи",
    "Слова и голос как в видео": "Слова й голос як у відео",
    "Слова и голос как в ролике": "Слова й голос як у ролику",
    "Смеётся": "Сміється",
    "Собираем видео": "Збираємо відео",
    "Собираем кружок": "Збираємо кружечок",
    "Создаём кружок": "Створюємо кружечок",
    "стиль {0}": "стиль {0}",
    "Стиль анимации": "Стиль анімації",
    "Стиль шаблона": "Стиль шаблону",
    "Столбики уровня звука": "Стовпчики рівня звуку",
    "Стрим": "Стрім",
    "Основной": "Основний",
    "Сфера": "Сфера",
    "Текст не прошёл проверку": "Текст не пройшов перевірку",
    "Текст проверен": "Текст перевірено",
    "Только для этого кружка": "Лише для цього кружечка",
    "Тут откроется тема чата, куда бот прислал видео": "Тут відкриється тема чату, куди бот надіслав відео",
    "Тут откроется тема чата, куда бот прислал кружок": "Тут відкриється тема чату, куди бот надіслав кружечок",
    "Удалить из кружка": "Видалити з кружечка",
    "Феррожидкость": "Ферорідина",
    "Фон на месте": "Фон на місці",
    "Формат задаёт шаблон": "Формат задає шаблон",
    "Фото говорит": "Фото говорить",
    "Фото ожило": "Фото ожило",
    "Чего не должно": "Чого не має бути",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "Чого не має бути в кадрі? Наприклад: зайвих рук, спотворень обличчя",
    "Чёрная магнитная жидкость с шипами": "Чорна магнітна рідина з шипами",
    "Читаем аудио": "Читаємо аудіо",
    "Что вы скажете? {0}": "Що ви скажете? {0}",
    "Что звучит вокруг? Дождь, город, костёр": "Що звучить довкола? Дощ, місто, багаття",
    "Что прозвучит? {0}": "Що прозвучить? {0}",
    "Что происходит": "Що відбувається",
    "Что скажет": "Що скаже",
    "Что скажет {0}? {1}": "Що скаже {0}? {1}",
    "Что скажет герой? {0}": "Що скаже герой? {0}",
    "Что скажет человек в кадре? {0}": "Що скаже людина в кадрі? {0}"
  },
  "zh": {
    "· кадр применится ко всему видео": "· 画面将应用于整个视频",
    "23 Февраля": "2 月 23 日",
    "8 Марта": "3 月 8 日",
    "Анимация готова": "动画已完成",
    "Анимация оживёт под ваш звук": "动画将随你的声音律动",
    "аудио {0}": "音频 {0}",
    "Аудио не прошло проверку": "音频未通过审核",
    "Аудио проверено": "音频已审核",
    "Аудио прочитано": "音频已读取",
    "Без изменений": "不做修改",
    "Без искажений": "无畸变",
    "Без лишних рук": "无多余的手",
    "Без надписей": "不带文字",
    "Без политики и запрещённых тем": "不涉及政治和违禁话题",
    "Бесконечное зеркало со светодиодами": "LED 无限镜",
    "близкий": "亲友",
    "Близкий": "亲友",
    "Бот уже прислал его в чат, в отдельную тему.": "机器人已把它发到聊天的单独话题中。",
    "Ваш вариант": "你的版本",
    "Ваше видео": "你的视频",
    "Ваши слова голосом «{0}»": "用「{0}」的声音说出你的话",
    "Ветер в волосах": "风吹头发",
    "вид {0}": "样式 {0}",
    "видео": "视频",
    "Видео говорит": "视频说话",
    "Видео из аудио": "音频生成视频",
    "Видео не прошло проверку": "视频未通过审核",
    "видео не создано": "视频未创建",
    "Видео повторится, пока звучит речь": "语音播放期间视频循环播放",
    "Видео проверено": "视频已检查",
    "Видео собрано": "视频已合成",
    "Видеооткрытка": "视频贺卡",
    "Видеосообщение Telegram, до минуты": "Telegram 视频消息，最长一分钟",
    "Войдёт первая минута из {0}": "仅使用 {0} 中的第一分钟",
    "Выберите в ряду ниже": "在下方一行中选择",
    "Выберите кадр": "选择画面",
    "Говорите: запись идёт": "请说话：正在录音",
    "Говорящий кружок": "会说话的圆形视频",
    "голос {0}": "声音 {0}",
    "Голос вашего варианта": "你的版本的声音",
    "Голос заменён": "声音已替换",
    "Голос записан": "声音已录制",
    "Голос наложен": "声音已叠加",
    "Голос персонажа": "角色声音",
    "Горизонт.": "横屏",
    "Губы повторят вашу речь, до минуты": "口型将跟随你的语音，最长一分钟",
    "Губы синхронизированы": "口型已同步",
    "Движение сгенерирует модель STEOS": "动作由 STEOS 模型生成",
    "Для ленты": "用于动态",
    "Для Reels, Shorts и сторис": "适用于 Reels、Shorts 和快拍",
    "Для YouTube и экрана": "适用于 YouTube 和屏幕",
    "до 1:00": "最长 1:00",
    "Доброе утро": "早上好",
    "за видео": "每个视频",
    "за кружок": "每个圆形视频",
    "Загрузите видео с лицом": "上传有人脸的视频",
    "Загрузите фото с лицом": "上传有人脸的照片",
    "Закончите запись": "请结束录音",
    "Закончите съёмку": "请结束拍摄",
    "Заменить аудио": "替换音频",
    "Заменить видео": "替换视频",
    "Записываем голос": "正在录制声音",
    "Запишите или загрузите речь": "录制或上传语音",
    "Зациклить": "循环",
    "Звук сгенерирует модель STEOS": "声音由 STEOS 模型生成",
    "из кружка": "从圆形视频中",
    "из этого кружка": "从此圆形视频中",
    "Изменить текст": "修改文字",
    "Кадр готов": "画面已完成",
    "Кадрируем в кружок": "正在裁成圆形视频",
    "Кадрируем видео": "正在裁剪视频",
    "Как в видео": "与视频一致",
    "Как оживить снимок? Например: моргает, улыбается, поворачивает голову": "怎样让照片动起来？例如：眨眼、微笑、转头",
    "Кольцо": "圆环",
    "кружок": "圆形视频",
    "Кружок из аудио": "音频生成圆形视频",
    "кружок не создан": "圆形视频未生成",
    "Кружок собран": "圆形视频已合成",
    "Кто говорит?": "谁在说话？",
    "Лица в кадре не было видно, поэтому голос наложен без подгонки губ.": "画面中看不到人脸，因此声音未做口型匹配。",
    "Лица не видно: голос наложим без подгонки губ": "看不到人脸：声音将不做口型匹配",
    "Лицо в кадре, из длинного выберете минуту": "画面中有人脸，长视频可从中选取一分钟",
    "Лицо крупно и смотрит в камеру": "面部特写，看向镜头",
    "максимум минута": "最长一分钟",
    "Матрица": "黑客帝国",
    "Микрофон недоступен, запись имитируется": "麦克风不可用，录音为模拟",
    "Минимум {0} символов": "至少 {0} 个字符",
    "можно своё фото или видео": "可以用自己的照片或视频",
    "Можно уйти с экрана: бот пришлёт готовое видео в чат.": "可以离开此页面：机器人会把完成的视频发到聊天中。",
    "Можно уйти с экрана: бот пришлёт готовый кружок в чат.": "可以离开此页面：机器人会把完成的圆形视频发到聊天中。",
    "Мой голос · клон": "我的声音 · 克隆",
    "Моргает и улыбается": "眨眼并微笑",
    "Морф": "变形",
    "Мягкое свечение, как в голосовом режиме": "柔和光晕，像语音模式一样",
    "на видео": "在视频中",
    "на кружке": "在圆形视频中",
    "Наезд камеры": "镜头推进",
    "Накладываем голос на видео": "正在把声音叠加到视频",
    "Написать текстом": "改为输入文字",
    "Напишите, что скажет": "写下要说的话",
    "Например: привет, с понедельником, пусть неделя будет лёгкой": "例如：嗨，周一快乐，愿你这周轻松顺利",
    "Не больше {0} знаков": "不超过 {0} 个字",
    "Не получилось собрать видео": "视频合成失败",
    "Не получилось собрать кружок": "圆形视频合成失败",
    "не скажет: нужен человек": "无法说话：需要真人",
    "Новые слова": "新台词",
    "Новый год": "新年",
    "Оживляем персонажа": "正在让角色动起来",
    "Оживляем фото": "正在让照片动起来",
    "Оставить мою речь": "保留我的语音",
    "Осциллограф на зелёном экране": "绿屏示波器",
    "Падающие символы": "下落的字符",
    "Переливающаяся капля меняет форму": "流光液滴变换形状",
    "Персонаж ожил": "角色已活起来",
    "Плавная лента звука": "流畅的声音波带",
    "Поворот головы": "转头",
    "Проверяем аудио": "正在检查音频",
    "Проверяем видео": "正在检查视频",
    "Проверяем текст": "正在检查文本",
    "Проиграть кружок": "播放圆形视频",
    "Просто так": "没什么理由",
    "Пульс": "脉冲",
    "Расходящиеся круги": "扩散的圆环",
    "Ретро": "复古",
    "Речь голосом: запись или файл": "用声音说话：录音或文件",
    "Рисуем анимацию звука": "正在绘制声音动画",
    "С днём рождения": "生日快乐",
    "С понедельником": "周一快乐",
    "Свадьба": "婚礼",
    "своя речь": "自己的语音",
    "Своя речь из видео": "视频中自己的语音",
    "Сделать видео": "制作视频",
    "Синхронизируем губы": "正在同步口型",
    "Слова и голос как в видео": "台词和声音与视频一致",
    "Слова и голос как в ролике": "台词和声音与视频一致",
    "Смеётся": "在笑",
    "Собираем видео": "正在合成视频",
    "Собираем кружок": "正在合成圆形视频",
    "Создаём кружок": "正在创建圆形视频",
    "стиль {0}": "风格 {0}",
    "Стиль анимации": "动画风格",
    "Стиль шаблона": "模板风格",
    "Столбики уровня звука": "音量柱",
    "Стрим": "直播",
    "Основной": "默认",
    "Сфера": "球体",
    "Текст не прошёл проверку": "文本未通过审核",
    "Текст проверен": "文本已审核",
    "Только для этого кружка": "仅用于此圆形视频",
    "Тут откроется тема чата, куда бот прислал видео": "这里会打开机器人发送视频的聊天话题",
    "Тут откроется тема чата, куда бот прислал кружок": "这里会打开机器人发送圆形视频的聊天话题",
    "Удалить из кружка": "从圆形视频中移除",
    "Феррожидкость": "磁流体",
    "Фон на месте": "保留背景",
    "Формат задаёт шаблон": "格式由模板决定",
    "Фото говорит": "照片说话",
    "Фото ожило": "照片已活起来",
    "Чего не должно": "不应出现的内容",
    "Чего не должно быть в кадре? Например: лишних рук, искажений лица": "画面中不应出现什么？例如：多余的手、面部变形",
    "Чёрная магнитная жидкость с шипами": "带尖刺的黑色磁性液体",
    "Читаем аудио": "正在读取音频",
    "Что вы скажете? {0}": "你要说什么？{0}",
    "Что звучит вокруг? Дождь, город, костёр": "周围有什么声音？雨声、城市、篝火",
    "Что прозвучит? {0}": "要播放什么？{0}",
    "Что происходит": "发生了什么",
    "Что скажет": "要说的话",
    "Что скажет {0}? {1}": "{0} 要说什么？{1}",
    "Что скажет герой? {0}": "主角要说什么？{0}",
    "Что скажет человек в кадре? {0}": "画面中的人要说什么？{0}"
  }
}
